const UNITS = {
    currency: {
        long: "₽",
        short: "₽"
    },
    percent: {
        long: "%",
        short: "%"
    },
    pieces: {
        long: "шт.",
        short: "шт."
    },
    percent_turnover: {
        long: "% от оборота",
        short: "% от оборота"
    },
    pieces_per_check: {
        long: "шт. в чеке",
        short: "шт. в чеке",
    },
    percent_target: {
        long: "% к кусту",
        short: "%",
    },
}

const STORES = [
    { id: 1, name: "126 НСК. Большая Медведица"},
    { id: 2, name: "134 КРД. Красная площадь Краснодар"},
    { id: 3, name: "329 МСК. Центральный Детский Мир"},
    { id: 4, name: "340 КРС Проспект Мира Красноярск"},
    { id: 5, name: "353 ПРМ. IMALL ЭСПЛАНАДА"},
    { id: 6, name: "363 МСК. ТОГАС КИДС Капитолий"},
    { id: 7, name: "366 МСК. ТОГАС КИДС Авиапарк"},
    { id: 8, name: "370 МСК. ТОГАС КИДС Княжий двор"},
    { id: 9, name: "106 МСК. ГОРОД"},
    { id: 10, name: "113 МСК. ГРАНД"},
    { id: 11, name: "114 МСК. Европолис Ростокино"},
    { id: 12, name: "116 МСК. ЕРЕВАН ПЛАЗА"},
    { id: 13, name: "117 МСК. АЗБУКА ВКУСА"},
    { id: 14, name: "119 МСК. ТЦ ФЕСТИВАЛЬ"},
    { id: 15, name: "159 МСК. Кутузовский"}
]

const EMPLOYEES = [
    {
        id: 1,
        name: "Филиппов Даниил",
        position_id: "designer"
    },
    {
        id: 2,
        name: "Константинопольский константинопулос",
        position_id: "designer"
    },
    {
        id: 3,
        name: "Алексей Столетов",
        position_id: "designer"
    },
    {
        id: 4,
        name: "Петр Равинский",
        position_id: "designer"
    },
    {
        id: 5,
        name: "Евгений Стоянов",
        position_id: "designer"
    },
    {
        id: 6,
        name: "Даниил Сологуб",
        position_id: "designer"
    },
    {
        id: 7,
        name: "Алексей Петров",
        position_id: "designer"
    },
    {
        id: 8,
        name: "Александр Кириллов",
        position_id: "designer"
    },
    {
        id: 9,
        name: "Кирилл Маликов",
        position_id: "designer"
    },
    {
        id: 10,
        name: "Яков Масленников",
        position_id: "designer"
    },
    {
        id: 11,
        name: "Филиппов Даниил",
        position_id: "designer"
    },
    {
        id: 12,
        name: "Константинопольский константинопулос",
        position_id: "designer"
    },
    {
        id: 13,
        name: "Алексей Столетов",
        position_id: "consultant",
    },
    {
        id: 14,
        name: "Петр Равинский",
        position_id: "consultant",
    },
    {
        id: 15,
        name: "Евгений Стоянов",
        position_id: "consultant",
    },
    {
        id: 16,
        name: "Даниил Сологуб",
        position_id: "consultant",
    },
    {
        id: 17,
        name: "Алексей Петров",
        position_id: "consultant"
    },
    {
        id: 18,
        name: "Александр Кириллов",
        position_id: "manager"
    },
    {
        id: 19,
        name: "Кирилл Маликов",
        position_id: "manager"
    },
    {
        id: 20,
        name: "Яков Масленников",
        position_id: "manager"
    }
]


const POSITIONS = [
    {
        id: "designer",
        name: "Дизайнеры"
    },
    {
        id: "consultant",
        name: "Консультанты"
    },
    {
        id: "manager",
        name: "Руководители бутиков"
    }
]

const GROUPS = {
    product: [
        {
            id: "gpki",
            name: "ГП+КИ",
            is_complex: true
        },
        {
            id: "gp",
            name: "ГП"
        },
        {
            id: "ki",
            name: "КИ"
        }
    ],
    assortment: [
        {
            id: "set",
            name: "КОМПЛЕКС"
        },
        {
            id: "bed_linen",
            name: "КПБ"
        },
        {
            id: "blankets",
            name: "ОДЕЯЛА"
        },
        {
            id: "pillows",
            name: "ПОДУШКИ"
        }
    ],
    positions: POSITIONS
}


const PERIODS = [
    {
        id: "quarter",
        name: "Квартал"
    },
    {
        id: "2025-03",
        name: "Март"
    },
    {
        id: "2025-04",
        name: "Апрель"
    },
    {
        id: "2025-05",
        name: "Май"
    }
]

const MONTH_GROUPS = [
    {
        id: "main",
        name: "Основные показатели"
    },
    {
        id: "plan",
        name: "Плановые показатели по месяцу"
    }
]

const QUARTER_GROUPS = [
    {
        "id": "plan",
        "name": "Плановые показатели за квартал"
    }
]

const YEAR_GROUPS = [{
    "id": "plan",
    "name": "Плановые показатели по году"
}]

const LABELS =  {
    plan: "План",
    fact: "Факт",
    percent_grid: "Процентная сетка",
    plan_threshold: "Выполнение плана",
    percent: "Процент",
    status: "Статус",
    store: "Бутик",
    result: "Результат",
    employee_name: "Имя Сотрудника",
    efficiency_full: "Эффективность сотрудников",
    efficiency_short: "Эффективность",
    statistics: "Статистика",
    statistics_short: "Статистика прироста",
    statistics_full: "Статистика общего прироста продаж",
    compare: "Прирост"
}

const ASSORTMENT = [
    {
        id: "bedding",
        name: "Постельное белье",
        image: "https://avatars.mds.yandex.net/i?id=d1c04a8dafdb8834f85ab0fbae64e42d92b64289-3608959-images-thumbs&n=13"
    },
    {
        id: "pillows",
        name: "Подушки",
        image: "https://avatars.mds.yandex.net/i?id=d1c04a8dafdb8834f85ab0fbae64e42d92b64289-3608959-images-thumbs&n=13"
    },
    {
        id: "mattress_protectors",
        name: "Наматрасники",
        image: "https://avatars.mds.yandex.net/i?id=d1c04a8dafdb8834f85ab0fbae64e42d92b64289-3608959-images-thumbs&n=13"
    },
    {
        id: "curtains",
        name: "Шторы",
        image: "https://avatars.mds.yandex.net/i?id=d1c04a8dafdb8834f85ab0fbae64e42d92b64289-3608959-images-thumbs&n=13"
    },
    {
        id: "bedspreads",
        name: "Покрывала",
        image: "https://avatars.mds.yandex.net/i?id=d1c04a8dafdb8834f85ab0fbae64e42d92b64289-3608959-images-thumbs&n=13"
    },
    {
        id: "plaids",
        name: "Пледы (Накидки и комфортеры)",
        image: "https://avatars.mds.yandex.net/i?id=d1c04a8dafdb8834f85ab0fbae64e42d92b64289-3608959-images-thumbs&n=13"
    }
];


const calendarWidget = {
    "type_id": "calendar",
    "group_id": "main",
    "items": [
        { "date": "2025-10-01", "is_workday": true },
        { "date": "2025-10-02", "is_workday": true },
        { "date": "2025-10-03", "is_workday": true },
        { "date": "2025-10-04", "is_workday": false },
        { "date": "2025-10-05", "is_workday": false },
        { "date": "2025-10-06", "is_workday": true},
        { "date": "2025-10-07", "is_workday": true },
        { "date": "2025-10-08", "is_workday": true },
        { "date": "2025-10-09", "is_workday": true },
        { "date": "2025-10-10", "is_workday": true },
        { "date": "2025-10-11", "is_workday": false },
        { "date": "2025-10-12", "is_workday": false },
        { "date": "2025-10-13", "is_workday": true },
        { "date": "2025-10-14", "is_workday": true },
        { "date": "2025-10-15", "is_workday": true },
        { "date": "2025-10-16", "is_workday": true },
        { "date": "2025-10-17", "is_workday": true },
        { "date": "2025-10-18", "is_workday": false },
        { "date": "2025-10-19", "is_workday": false },
        { "date": "2025-10-20", "is_workday": true },
        { "date": "2025-10-21", "is_workday": true },
        { "date": "2025-10-22", "is_workday": true },
        { "date": "2025-10-23", "is_workday": true },
        { "date": "2025-10-24", "is_workday": true },
        { "date": "2025-10-25", "is_workday": true },
        { "date": "2025-10-26", "is_workday": true },
        { "date": "2025-10-27", "is_workday": true },
        { "date": "2025-10-28", "is_workday": true, is_current: true },
        { "date": "2025-10-29", "is_workday": true },
        { "date": "2025-10-30", "is_workday": true },
        { "date": "2025-10-31", "is_workday": true }
    ]
};

const progressWidgetDesigner = {
    "type_id": "progress",
    "name": "Дневная эффективность",
    "group_id": "main",
    "labels": {
        "plan": "План",
        "fact": "Факт",
        "difference": "До выполнения плана:",
        "percent": "Процент",
        "status": "Статус",
        "quote": "Выполнение плана — задача всегда не легкая, но награда стоит усилий! Мы уверенны, вы справитесь с задачей!"
    },
    "items": [{
        "plan": {
            "amount": 4000000,
            "unit_id": "currency"
        },
        "fact": {
            "amount": 4000,
            "unit_id": "currency"
        },
        "value": {
            "amount": 10,
            "unit_id": "percent"
        }
    }]
}

const progressWidgetConsultant = {
    "type_id": "progress",
    "name": "Дневная эффективность",
    "group_id": "main",
    "labels": {
        "plan": "План",
        "fact": "Факт",
        "difference": "До выполнения плана:",
        "percent": "Процент",
        "status": "Статус",
        "quote": "Выполнение плана — задача всегда не легкая, но награда стоит усилий! Мы уверенны, вы справитесь с задачей!"
    },
    "items": [{
        "plan": {
            "amount": 4000000,
            "unit_id": "currency"
        },
        "fact": {
            "amount": 3550000,
            "unit_id": "currency"
        },
        "value": {
            "amount": 50,
            "unit_id": "percent"
        }
    }]
}

const progressWidgetManager = {
    "type_id": "progress",
    "name": "Дневная эффективность",
    "group_id": "main",
    "labels": {
        "plan": "План",
        "fact": "Факт",
        "difference": "До выполнения плана:",
        "percent": "Процент",
        "status": "Статус",
        "quote": "Выполнение плана — задача всегда не легкая"
    },
    "items": [{
        "plan": {
            "amount": 4000000,
            "unit_id": "currency"
        },
        "fact": {
            "amount": 4000000,
            "unit_id": "currency"
        },
        "value": {
            "amount": 100,
            "unit_id": "percent"
        }
    }]
}

const progressWidgetTerritorial = {
    "type_id": "progress",
    "name": "Дневная эффективность",
    "group_id": "main",
    "labels": {
        "plan": "План",
        "fact": "Факт",
        "difference": "До выполнения плана:",
        "percent": "Процент",
        "status": "Статус",
        "quote": "Выполнение плана — задача всегда не легкая, но награда стоит усилий! Мы уверенны, вы справитесь с задачей! Вы уже сделали первый шаг. А значит, вы на правильном пути!"
    },
    "items": [{
        "plan": {
            "amount": 99000000,
            "unit_id": "currency"
        },
        "fact": {
            "amount": 4000000,
            "unit_id": "currency"
        },
        "value": {
            "amount": 200,
            "unit_id": "percent"
        }
    }]
}

const leagueStatusDesigner = {
    "type_id": "league_status",
    "group_id": "main",
    "items": [{
        "id": "sales",
        "name": "Рейтинг по сумме продаж",
        "league": {
            "id": "iron", // iron |  bronze | silver | gold
            "name": "Железная лига",
        },
        "rating": {
            "current": 130,
            "total": 268,
            "direction": "up",
            "is_league_leader": true
        },
        "goals": [{
            "name": "Вернуть позицию",
            "value": { "amount": 100000, "unit_id": "currency" }
        }, {
            "name": "Следующая десятка",
            "value": { "amount": 400000, "unit_id": "currency" }
        }, {
            "name": "Первое место",
            "value": { "amount": 1200000, "unit_id": "currency" }
        }]
    }, {
        "id": "plan",
        "name": "Рейтинг выполнения плана",
        "league": {
            "id": "iron",
            "name": "Железная лига",
        },
        "rating": {
            "current": 130,
            "total": 268,
            "direction": "down",
            "is_league_leader": false
        },
        "goals": [{
            "name": "Вернуть позицию",
            "value": { "amount": 100000, "unit_id": "currency" }
        }, {
            "name": "Следующая десятка",
            "value": { "amount": 400000, "unit_id": "currency" }
        }, {
            "name": "Первое место",
            "value": { "amount": 1200000, "unit_id": "currency" }
        }]
    }],
}

const leagueStatusConsultant = {
    "type_id": "league_status",
    "group_id": "main",
    "items": [{
        "id": "sales",
        "name": "Рейтинг по сумме продаж",
        "league": {
            "id": "bronze", // iron |  bronze | silver | gold
            "name": "Бронзовая лига",
        },
        "rating": {
            "current": 12,
            "total": 268,
            "direction": "up" // up | down | stable
        },
        "goals": [{
            "name": "Вернуть позицию",
            "value": { "amount": 100000, "unit_id": "currency" }
        }, {
            "name": "Следующая десятка",
            "value": { "amount": 400000, "unit_id": "currency" }
        }, {
            "name": "Первое место",
            "value": { "amount": 1200000, "unit_id": "currency" }
        }]
    }, {
        "id": "plan",
        "name": "Рейтинг выполнения плана",
        "league": {
            "id": "iron",
            "name": "Железная лига",
        },
        "rating": {
            "current": 130,
            "total": 268,
            "direction": "down",
            "is_league_leader": true
        },
        "goals": [{
            "name": "Вернуть позицию",
            "value": { "amount": 100000, "unit_id": "currency" }
        }, {
            "name": "Следующая десятка",
            "value": { "amount": 400000, "unit_id": "currency" }
        }, {
            "name": "Первое место",
            "value": { "amount": 1200000, "unit_id": "currency" }
        }]
    }],
}

const leagueStatusManager = {
    "type_id": "league_status",
    "group_id": "main",
    "items": [{
        "id": "sales",
        "name": "Рейтинг по сумме продаж",
        "league": {
            "id": "silver", // iron |  bronze | silver | gold
            "name": "Серебряная лига",
        },
        "rating": {
            "current": 2,
            "total": 5,
            "direction": "stable" // up | down | stable
        },
        "goals": [{
            "name": "Вернуть позицию",
            "value": { "amount": 100000, "unit_id": "currency" }
        }, {
            "name": "Следующая десятка",
            "value": { "amount": 400000, "unit_id": "currency" }
        }, {
            "name": "Первое место",
            "value": { "amount": 1200000, "unit_id": "currency" }
        }]
    }, {
        "id": "plan",
        "name": "Рейтинг выполнения плана",
        "league": {
            "id": "iron",
            "name": "Железная лига",
        },
        "rating": {
            "current": 130,
            "total": 268,
            "direction": "down",
            "is_league_leader": true
        },
        "goals": [{
            "name": "Вернуть позицию",
            "value": { "amount": 100000, "unit_id": "currency" }
        }, {
            "name": "Следующая десятка",
            "value": { "amount": 400000, "unit_id": "currency" }
        }, {
            "name": "Первое место",
            "value": { "amount": 1200000, "unit_id": "currency" }
        }]
    }],
}


const leagueStatusTerritorial = {
    "type_id": "league_status",
    "group_id": "main",
    "items": [{
        "id": "sales",
        "name": "Рейтинг по сумме продаж",
        "league": {
            "id": "gold", // iron |  bronze | silver | gold
            "name": "Золотая лига",
        },
        "rating": {
            "current": 2,
            "total": 5,
            "direction": "up", // up | down | stable
            "is_league_leader": true
        },
        "goals": []
    }, {
        "id": "plan",
        "name": "Рейтинг выполнения плана",
        "league": {
            "id": "iron",
            "name": "Железная лига",
        },
        "rating": {
            "current": 1,
            "total": 268,
            "direction": "down",
        },
        "goals": [{
            "name": "Вернуть позицию",
            "value": { "amount": 100000, "unit_id": "currency" }
        }, {
            "name": "Следующая десятка",
            "value": { "amount": 400000, "unit_id": "currency" }
        }, {
            "name": "Первое место",
            "value": { "amount": 1200000, "unit_id": "currency" }
        }]
    }],
}


const lineChartDesigner = {
    type_id: "line_chart",
    name: "График продаж за месяц",
    group_id: "main",
    labels: {
        current: "Текущий месяц",
        previous: "Прошлый месяц",
        plan: "Норма продаж на текущее число",
        fact: "Фактические продажи",
    },
    workdays: 22,
    plan: {
        amount: 110000,
        unit_id: "currency"
    },
    fact: {
        amount: 91000,
        unit_id: "currency"
    },
    items: [{
        current_month: [
            { date: "2025-10-01", value: 105000 },
            { date: "2025-10-02", value: 98000 },
            { date: "2025-10-03", value: 112000 },
            { date: "2025-10-04", value: 80000 },
            { date: "2025-10-05", value: 121000 },
            { date: "2025-10-06", value: 122000 },
            { date: "2025-10-07", value: 82000 },
            { date: "2025-10-08", value: 74000 },
            { date: "2025-10-09", value: 126000 },
            { date: "2025-10-10", value: 120000 },
            { date: "2025-10-11", value: 130000 },
            { date: "2025-10-12", value: 170000 },
            { date: "2025-10-13", value: 155000 },
            { date: "2025-10-14", value: 150000 },
            { date: "2025-10-15", value: 150000 },
            { date: "2025-10-16", value: 200000 },
            { date: "2025-10-17", value: 138000 },
            { date: "2025-10-18", value: 140000 },
        ],
        previous_month: [
            { date: "2025-09-01", value: 95000 },
            { date: "2025-09-02", value: 97000 },
            { date: "2025-09-03", value: 100000 },
            { date: "2025-09-04", value: 110000 },
            { date: "2025-09-05", value: 113000 },
            { date: "2025-09-06", value: 118000 },
            { date: "2025-09-07", value: 200000 },
            { date: "2025-09-08", value: 119000 },
            { date: "2025-09-09", value: 180000 },
            { date: "2025-09-10", value: 123000 },
            { date: "2025-09-11", value: 119000 },
            { date: "2025-09-12", value: 130000 },
            { date: "2025-09-13", value: 117000 },
            { date: "2025-09-14", value: 122000 },
            { date: "2025-09-15", value: 45000 },
            { date: "2025-09-16", value: 121000 },
            { date: "2025-09-17", value: 110000 },
            { date: "2025-09-18", value: 120000 },
        ]
    }]
};

const lineChartConsultant = {
    type_id: "line_chart",
    name: "График продаж за месяц",
    group_id: "main",
    labels: {
        current: "Текущий месяц",
        previous: "Прошлый месяц",
        plan: "Норма продаж на текущее число",
        fact: "Фактические продажи",
    },
    workdays: 22,
    plan: {
        amount: 1100000,
        unit_id: "currency"
    },
    fact: {
        amount: 790000,
        unit_id: "currency"
    },
    items: [{
        current_month: [
            { date: "2025-10-01", value: 105000 },
            { date: "2025-10-02", value: 98000 },
            { date: "2025-10-03", value: 120000 },
            { date: "2025-10-04", value: 118000 },
            { date: "2025-10-05", value: 111000 },
            { date: "2025-10-06", value: 102000 },
            { date: "2025-10-07", value: 105000 },
            { date: "2025-10-08", value: 147000 },
            { date: "2025-10-09", value: 136000 },
            { date: "2025-10-10", value: 129000 },
            { date: "2025-10-11", value: 130000 },
            { date: "2025-10-12", value: 112000 },
            { date: "2025-10-13", value: 114000 },
            { date: "2025-10-14", value: 91000 },
            { date: "2025-10-15", value: 98000 },
            { date: "2025-10-16", value: 136000 },
            { date: "2025-10-17", value: 138000 },
            { date: "2025-10-18", value: 40000 },
            { date: "2025-10-19", value: 8000 },
        ],
        previous_month: [
            { date: "2025-09-01", value: 95000 },
            { date: "2025-09-02", value: 97000 },
            { date: "2025-09-03", value: 100000 },
            { date: "2025-09-04", value: 110000 },
            { date: "2025-09-05", value: 113000 },
            { date: "2025-09-06", value: 118000 },
            { date: "2025-09-07", value: 120000 },
            { date: "2025-09-08", value: 119000 },
            { date: "2025-09-09", value: 121000 },
            { date: "2025-09-10", value: 123000 },
            { date: "2025-09-11", value: 119000 },
            { date: "2025-09-12", value: 115000 },
            { date: "2025-09-13", value: 117000 },
            { date: "2025-09-14", value: 122000 },
            { date: "2025-09-15", value: 125000 },
            { date: "2025-09-16", value: 121000 },
            { date: "2025-09-17", value: 118000 },
            { date: "2025-09-18", value: 116000 },
            { date: "2025-09-19", value: 120000 },
            { date: "2025-09-20", value: 119000 },
            { date: "2025-09-21", value: 119000 },
        ]
    }]
};

const lineChartManager = {
    type_id: "line_chart",
    name: "График продаж за месяц",
    group_id: "main",
    labels: {
        current: "Текущий месяц",
        previous: "Прошлый месяц",
        plan: "Норма продаж на текущее число",
        fact: "Фактические продажи",
    },
    workdays: 30,
    plan: {
        amount: 5000000,
        unit_id: "currency"
    },
    fact: {
        amount: 4000000,
        unit_id: "currency"
    },
    items: [{
        current_month: [
            { date: "2025-10-01", value: 805000 },
            { date: "2025-10-02", value: 928000 },
            { date: "2025-10-03", value: 812000 },
            { date: "2025-10-04", value: 918000 },
            { date: "2025-10-05", value: 721000 },
            { date: "2025-10-06", value: 622000 },
            { date: "2025-10-07", value: 725000 },
            { date: "2025-10-08", value: 827000 },
            { date: "2025-10-09", value: 826000 },
            { date: "2025-10-10", value: 629000 },
            { date: "2025-10-11", value: 830000 },
            { date: "2025-10-12", value: 732000 },
            { date: "2025-10-13", value: 934000 },
            { date: "2025-10-14", value: 631000 },
            { date: "2025-10-15", value: 528000 },
            { date: "2025-10-16", value: 736000 },
            { date: "2025-10-17", value: 838000 },
            { date: "2025-10-18", value: 840000 },
            { date: "2025-10-19", value: 942000 },
            { date: "2025-10-20", value: 639000 },
            { date: "2025-10-21", value: 637000 },
            { date: "2025-10-22", value: 643000 },
            { date: "2025-10-23", value: 845000 },
            { date: "2025-10-24", value: 114700 },
            { date: "2025-10-25", value: 115000 },
            { date: "2025-10-26", value: 115200 },
            { date: "2025-10-27", value: 0 },
        ],
        previous_month: [
            { date: "2025-09-01", value: 795000 },
            { date: "2025-09-02", value: 997000 },
            { date: "2025-09-03", value: 900000 },
            { date: "2025-09-04", value: 810000 },
            { date: "2025-09-05", value: 813000 },
            { date: "2025-09-06", value: 918000 },
            { date: "2025-09-07", value: 920000 },
            { date: "2025-09-08", value: 619000 },
            { date: "2025-09-09", value: 821000 },
            { date: "2025-09-10", value: 823000 },
            { date: "2025-09-11", value: 819000 },
            { date: "2025-09-12", value: 515000 },
            { date: "2025-09-13", value: 517000 },
            { date: "2025-09-14", value: 522000 },
            { date: "2025-09-15", value: 725000 },
            { date: "2025-09-16", value: 721000 },
            { date: "2025-09-17", value: 818000 },
            { date: "2025-09-18", value: 816000 },
            { date: "2025-09-19", value: 920000 },
            { date: "2025-09-20", value: 819000 },
            { date: "2025-09-21", value: 719000 },
            { date: "2025-09-22", value: 819000 },
            { date: "2025-09-23", value: 922000 },
            { date: "2025-09-24", value: 923000 },
            { date: "2025-09-25", value: 924000 },
            { date: "2025-09-26", value: 926000 },
            { date: "2025-09-27", value: 827000 },
            { date: "2025-09-28", value: 829000 },
            { date: "2025-09-29", value: 830000 },
            { date: "2025-09-30", value: 832000 },
            { date: "2025-09-31", value: 833000 }
        ]
    }]
};

const lineChartTerritorial = {
    type_id: "line_chart",
    name: "График продаж за месяц",
    group_id: "main",
    labels: {
        current: "Текущий месяц",
        previous: "Прошлый месяц",
        plan: "Норма продаж на текущее число",
        fact: "Фактические продажи",
    },
    workdays: 31,
    plan: {
        amount: 910000,
        unit_id: "currency"
    },
    fact: {
        amount: 890000,
        unit_id: "currency"
    },
    items: [{
        current_month: [
            { date: "2025-10-01", value: 105000 },
            { date: "2025-10-02", value: 98000 },
            { date: "2025-10-03", value: 112000 },
            { date: "2025-10-04", value: 118000 },
            { date: "2025-10-05", value: 121000 },
            { date: "2025-10-06", value: 122000 },
            { date: "2025-10-07", value: 125000 },
            { date: "2025-10-08", value: 127000 },
            { date: "2025-10-09", value: 126000 },
            { date: "2025-10-10", value: 129000 },
            { date: "2025-10-11", value: 130000 },
            { date: "2025-10-12", value: 132000 },
            { date: "2025-10-13", value: 134000 },
            { date: "2025-10-14", value: 131000 },
            { date: "2025-10-15", value: 128000 },
            { date: "2025-10-16", value: 136000 },
            { date: "2025-10-17", value: 138000 },
            { date: "2025-10-18", value: 140000 },
            { date: "2025-10-19", value: 162000 },
            { date: "2025-10-20", value: 169000 },
            { date: "2025-10-21", value: 167000 },
            { date: "2025-10-22", value: 173000 },
            { date: "2025-10-23", value: 175000 },
            { date: "2025-10-24", value: 187000 },
            { date: "2025-10-25", value: 190000 },
            { date: "2025-10-26", value: 192000 },
            { date: "2025-10-27", value: 199000 },
        ],
        previous_month: [
            { date: "2025-09-01", value: 95000 },
            { date: "2025-09-02", value: 97000 },
            { date: "2025-09-03", value: 100000 },
            { date: "2025-09-04", value: 110000 },
            { date: "2025-09-05", value: 113000 },
            { date: "2025-09-06", value: 118000 },
            { date: "2025-09-07", value: 120000 },
            { date: "2025-09-08", value: 119000 },
            { date: "2025-09-09", value: 121000 },
            { date: "2025-09-10", value: 123000 },
            { date: "2025-09-11", value: 119000 },
            { date: "2025-09-12", value: 115000 },
            { date: "2025-09-13", value: 117000 },
            { date: "2025-09-14", value: 122000 },
            { date: "2025-09-15", value: 125000 },
            { date: "2025-09-16", value: 121000 },
            { date: "2025-09-17", value: 118000 },
            { date: "2025-09-18", value: 116000 },
            { date: "2025-09-19", value: 120000 },
            { date: "2025-09-20", value: 119000 },
            { date: "2025-09-21", value: 119000 },
            { date: "2025-09-22", value: 119000 },
            { date: "2025-09-23", value: 122000 },
            { date: "2025-09-24", value: 123000 },
            { date: "2025-09-25", value: 124000 },
            { date: "2025-09-26", value: 126000 },
            { date: "2025-09-27", value: 127000 },
            { date: "2025-09-28", value: 129000 },
            { date: "2025-09-29", value: 130000 },
            { date: "2025-09-30", value: 132000 },
            { date: "2025-09-31", value: 133000 }
        ]
    }]
};

const leagueRating = {
    "type_id": "league_rating",
    "name": "Лига первых",
    "group_id": "main",
    "labels": {
        "plan": "План",
        "sales": "Продажи",
        "leaders": "Лидеры",
        "my_place": "Мое место"
    },
    plan: {
        items: [{
            "place": 1,
            "employee_id": 1,
            "value": { "amount": 200, "unit_id": "percent" },
            "league": "gold",
            "is_league_leader": true
        }, {
            "place": 2,
            "employee_id": 2,
            "value": { "amount": 110, "unit_id": "percent" },
            "league": "gold",
            "is_league_leader": false
        }, {
            "place": 3,
            "employee_id": 3,
            "value": { "amount": 100, "unit_id": "percent" },
            "league": "gold",
            "is_league_leader": false
        }, {
            "place": 4,
            "employee_id": 4,
            "value": { "amount": 100, "unit_id": "percent" },
            "league": "silver",
            "is_league_leader": true
        },{
            "place": 5,
            "employee_id": 5,
            "value": { "amount": 95, "unit_id": "percent" },
            "league": "silver",
            "is_league_leader": false
        }, {
            "place": 6,
            "employee_id": 6,
            "value": { "amount": 95, "unit_id": "percent" },
            "league": "silver",
            "is_league_leader": false
        },{
            "place": 7,
            "employee_id": 7,
            "value": { "amount": 95, "unit_id": "percent" },
            "league": "bronze",
            "is_league_leader": true
        },{
            "place": 8,
            "employee_id": 8,
            "value": { "amount": 95, "unit_id": "percent" },
            "league": "bronze",
            "is_league_leader": false
        },{
            "place": 9,
            "employee_id": 9,
            "value": { "amount": 95, "unit_id": "percent" },
            "league": "bronze",
            "is_league_leader": false
        },{
            "place": 10,
            "employee_id": 10,
            "value": { "amount": 95, "unit_id": "percent" },
            "place_change": { "direction": "stable", "value": 0 },
            "league": "iron",
            "is_league_leader": false,
            "is_current": true,
        },{
            "place": 11,
            "employee_id": 11,
            "value": { "amount": 80, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        },{
            "place": 12,
            "employee_id": 12,
            "value": { "amount": 70, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        },{
            "place": 13,
            "employee_id": 13,
            "value": { "amount": 60, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        },{
            "place": 14,
            "employee_id": 14,
            "value": { "amount": 50, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        },{
            "place": 15,
            "employee_id": 15,
            "value": { "amount": 49, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        },{
            "place": 16,
            "employee_id": 16,
            "place_change": { "direction": "down", "value": 2 },
            "value": { "amount": 40, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        },{
            "place": 17,
            "employee_id": 17,
            "value": { "amount": 30, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        },{
            "place": 18,
            "employee_id": 18,
            "value": { "amount": 20, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        },{
            "place": 19,
            "employee_id": 19,
            "value": { "amount": 10, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        },{
            "place": 20,
            "employee_id": 20,
            "value": { "amount": 0, "unit_id": "percent" },
            "league": "iron",
            "is_league_leader": false
        }]
    },
    sales: {
        items: [
            { "place": 1, "employee_id": 1, "league": "gold",  "is_league_leader": false},
            { "place": 2, "employee_id": 2, "league": "silver", "is_current": true, "place_change": { "direction": "up", "value": 2 }, "is_league_leader": false },
            { "place": 3, "employee_id": 3, "league": "bronze", "is_league_leader": false },
            { "place": 4, "employee_id": 4, "league": "iron", "is_league_leader": false },
            { "place": 5, "employee_id": 5, "league": "iron", "is_league_leader": false }]
    }
}


const productGroupsPrices = {
    type_id: "product_groups_prices",
    name: "Средняя стоимость товара в группе",
    group_id: "main",

    labels: {
        product_group: "Группа товара",
        plan: "Средняя стоимость товара в группе по сети",
        fact: "Личный результат в группе",
        status: "Статус",
        ahead: "Опережение",
        normal: "Норма",
        behind: "Отставание"
    },

    items: [{
        assortment_id: "bedding",
        plan: { amount: 210500, unit_id: "currency" },
        fact: { amount: 360500, unit_id: "currency" },
        status: "ahead"
    }, {
        assortment_id: "pillows",
        plan: { amount: 110500, unit_id: "currency" },
        fact: { amount: 460500, unit_id: "currency" },
        status: "normal"
    }, {
        assortment_id: "mattress_protectors",
        plan: { amount: 310500, unit_id: "currency" },
        fact: { amount: 560500, unit_id: "currency" },
        status: "normal"
    }, {
        assortment_id: "curtains",
        plan: { amount: 410500, unit_id: "currency" },
        fact: { amount: 760500, unit_id: "currency" },
        status: "normal"
    }, {
        assortment_id: "bedspreads",
        plan: { amount: 510500, unit_id: "currency" },
        fact: { amount: 960500, unit_id: "currency" },
        status: "behind"
    }, {
        assortment_id: "plaids",
        plan: { amount: 210500, unit_id: "currency" },
        fact: { amount: 160500, unit_id: "currency" },
        status: "behind"
    }, {
        assortment_id: "plaids",
        plan: { amount: 210500, unit_id: "currency" },
        fact: { amount: 160500, unit_id: "currency" },
        status: "behind"
    }]
};

const pieChart = {
    name: 'Доля в личных продажах',
    group_id: "main",
    type_id: 'pie_chart',
    items: [{
        name: 'Комплекты постельного белья',
        value: {
            amount: 40,
            unit_id: 'percent'
        },
        color: '#10C525'
    }, {
        name: 'Подушки',
        value: {
            amount: 40,
            unit_id: 'percent'
        },
        color: '#92DD29'
    }, {
        name: 'Наматрасники',
        value: {
            amount: 10,
            unit_id: 'percent'
        },
        color: '#B1EB2C'
    }, {
        name: 'Шторы',
        value: {
            amount: 5,
            unit_id: 'percent'
        },
        color: '#CAF52E'
    }, {
        name: 'Покрывала',
        value: {
            amount: 4,
            unit_id: 'percent'
        },
        color: '#E0FF30'
    }, {
        name: 'Пледы (Накидки и комфортеры)',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#F8FF30'
    }, {
        name: 'Декоративные подушки',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FFF130'
    }, {
        name: 'Полотенца',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FFCF30'
    }, {
        name: 'Комплекты полотенец',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FFA530'
    }, {
        name: 'Коврики для ванной комнаты',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FF8229'
    }, {
        name: 'Халаты',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FF6714'
    }, {
        name: 'Одежда для дома',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FF4E08'
    }, {
        name: 'Обувь',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FC2200'
    }, {
        name: 'Столовое белье',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#DE0000'
    }, {
        name: 'Кухонный текстиль',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#BA0000'
    }, {
        name: 'Подставки под горячие',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Подставки под горячее',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Аксессуары',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Посуда',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Ароматы',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Уход для тела',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Аксессуары для ванной',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Напольные тканые ковры',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Матрасы',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Мебель',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Отоваренные сертификаты',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }, {
        name: 'Проданые сертификаты',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#A10000'
    }]
}

const pieChartConsultant = {
    name: 'Доля в личных продажах',
    group_id: "main",
    type_id: 'pie_chart',
    items: [{
        name: 'Комплекты постельного белья',
        value: {
            amount: 40,
            unit_id: 'percent'
        },
        color: '#10C525'
    }, {
        name: 'Подушки',
        value: {
            amount: 40,
            unit_id: 'percent'
        },
        color: '#92DD29'
    }, {
        name: 'Наматрасники',
        value: {
            amount: 10,
            unit_id: 'percent'
        },
        color: '#B1EB2C'
    }, {
        name: 'Шторы',
        value: {
            amount: 5,
            unit_id: 'percent'
        },
        color: '#CAF52E'
    }, {
        name: 'Покрывала',
        value: {
            amount: 4,
            unit_id: 'percent'
        },
        color: '#E0FF30'
    }, {
        name: 'Пледы (Накидки и комфортеры)',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#F8FF30'
    }, {
        name: 'Декоративные подушки',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FFF130'
    }, {
        name: 'Полотенца',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FFCF30'
    }, {
        name: 'Комплекты полотенец',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FFA530'
    }, {
        name: 'Коврики для ванной комнаты',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FF8229'
    }, {
        name: 'Халаты',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FF6714'
    }]
}

const pieChartManager = {
    name: 'Доля в личных продажах',
    group_id: "main",
    type_id: 'pie_chart',
    items: [{
        name: 'Комплекты постельного белья',
        value: {
            amount: 40,
            unit_id: 'percent'
        },
        color: '#10C525'
    }, {
        name: 'Подушки',
        value: {
            amount: 40,
            unit_id: 'percent'
        },
        color: '#92DD29'
    }, {
        name: 'Наматрасники',
        value: {
            amount: 20,
            unit_id: 'percent'
        },
        color: '#B1EB2C'
    }, {
        name: 'Шторы',
        value: {
            amount: 30,
            unit_id: 'percent'
        },
        color: '#CAF52E'
    }, {
        name: 'Халаты',
        value: {
                amount: 20,
                unit_id: 'percent'
            },
            color: '#FFCF30'
        }
    ]
}

const pieChartTerritorial = {
    name: 'Доля в личных продажах',
    group_id: "main",
    type_id: 'pie_chart',
    items: [{
        name: 'Комплекты постельного белья',
        value: {
            amount: 40,
            unit_id: 'percent'
        },
        color: '#10C525'
    }, {
        name: 'Подушки',
        value: {
            amount: 40,
            unit_id: 'percent'
        },
        color: '#92DD29'
    }, {
        name: 'Наматрасники',
        value: {
            amount: 10,
            unit_id: 'percent'
        },
        color: '#B1EB2C'
    }, {
        name: 'Шторы',
        value: {
            amount: 5,
            unit_id: 'percent'
        },
        color: '#CAF52E'
    }, {
        name: 'Покрывала',
        value: {
            amount: 4,
            unit_id: 'percent'
        },
        color: '#E0FF30'
    }, {
        name: 'Пледы (Накидки и комфортеры)',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#F8FF30'
    }, {
        name: 'Декоративные подушки',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FFF130'
    }, {
        name: 'Полотенца',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FFCF30'
    }, {
        name: 'Комплекты полотенец',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FFA530'
    }, {
        name: 'Коврики для ванной комнаты',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FF8229'
    }, {
        name: 'Халаты',
        value: {
            amount: 2,
            unit_id: 'percent'
        },
        color: '#FF6714'
    }]
}

const generateDashboard = (params) =>  {
    const { month, quarter, year, bonuses } = params

    return {
        status: "success",
        data: {
            item: {
                content: {
                    email: "user@togas.com",
                    updated_at: "2025-10-27T15:35:00",
                    units: UNITS,
                    stores: STORES,
                    employees: EMPLOYEES,
                    groups: GROUPS,
                    periods: PERIODS,
                    positions: POSITIONS,
                    assortment: ASSORTMENT,
                    content: {
                        month,
                        quarter,
                        year
                    },
                    bonuses
                }
            }
        }
    }
}

const singleNoGroupItems = (value = 60) => {
    return [{
        store_id: null,
        plan: {
            amount: 300000000,
            unit_id: "currency"
        },
        fact: {
            amount: 150000000,
            unit_id: "currency"
        },
        value: {
            amount: value,
            unit_id: "percent"
        }
    }]
}

const createItemsWithStores = (storeIds, planAmount, factAmount, unitId, values = [], factHint = null) => {
    return storeIds.map((id, index) => {
        const item = {
            store_id: id,
            plan: {
                amount: planAmount,
                unit_id: unitId,
            },
            fact: {
                amount: factAmount,
                unit_id: unitId,
            },
            value: {
                amount: values[index] ?? 60,
                unit_id: "percent",
            },
        };

        if (factHint) {
            item.fact_hint = factHint;
        }

        return item;
    });
}

const itemsWithStores = createItemsWithStores(
    [null, 1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    3000000,
    1500000,
    "currency",
    [60, 30, 60, 90, 120, 90, 90, 90, 90, 90, 90, 90, 90, 10, 10],
    "17 500 ₽ в день"
);

function generateItemsWithStoresAndGroups(
    stores,
    groups,
    plan,
    fact,
    values,
    factHint,
    unitId = "currency",
    valueUnitId = "percent",
    showSign = false,
    valuesPerStore = null,
    customNullStoreItems = []
) {
    const items = [];

    if (customNullStoreItems.length > 0) {
        customNullStoreItems.forEach(item => items.push(item));
    } else {
        groups.forEach((group, idx) => {
            const item = {
                store_id: null,
                group_id: group,
                plan: { amount: plan, unit_id: unitId },
                fact: { amount: fact, unit_id: unitId },
                value: { amount: values[idx], unit_id: valueUnitId }
            };
            if (factHint) item.fact_hint = factHint;
            if (showSign) {
                item.plan.show_sign = true;
                item.fact.show_sign = true;
            }
            items.push(item);
        });
    }

    stores.forEach(store_id => {
        groups.forEach((group, idx) => {
            const valueAmount = valuesPerStore
                ? valuesPerStore?.[store_id]?.[idx]
                : values[idx];

            const item = {
                store_id,
                group_id: group,
                plan: { amount: plan, unit_id: unitId },
                fact: { amount: fact, unit_id: unitId },
                value: { amount: valueAmount, unit_id: valueUnitId }
            };
            if (factHint) item.fact_hint = factHint;
            if (showSign) {
                item.plan.show_sign = true;
                item.fact.show_sign = true;
            }
            items.push(item);
        });
    });

    return items;
}

const groups = ["gpki", "gp", "ki"];
const stores = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];

const values = [60, 20, 10, 130];
const valuesPerStore = {
    1: [30, 40, 40],
    2: [60, 50, 70],
    3: [90, 70, 30],
    4: [100, 30, 20],
    5: [120, 20, 5],
    6: [90, 130, 60],
    7: [90, 30, 40],
    8: [90, 80, 10],
    9: [90, 10, 10],
    10: [90, 10, 10],
    11: [90, 10, 10],
    12: [90, 10, 10],
    13: [90, 10, 10],
    14: [10, 10, 10],
    15: [10, 10, 10]
};

const itemsWithStoresAndGroups = generateItemsWithStoresAndGroups(
    stores,
    groups,
    3000000,
    1500000,
    values,
    "17 500 ₽ в день",
    "currency",
    "percent" ,
    false
);

const generateEfficiencyItems = () => {
    const items = [];

    const values = [
        [120, 83, 94, 91],
        [100, 83, 67, 83],
        [100, 17, 23, 85],
        [92, 38, 55, 90],
        [90, 75, 12, 79],
        [90, 91, 89, 87],
        [60, 50, 74, 78],
        [60, 84, 83, 82],
        [30, 92, 31, 93],
        [30, 88, 87, 85],
        [20, 51, 78, 20],
        [90, 29, 92, 90],
        [40, 85, 12, 84],
        [80, 68, 86, 89],
        [90, 87, 91, 88],
        [30, 40, 81, 83],
        [130, 86, 85, 87],
        [10, 90, 89, 91],
        [80, 83, 2, 84],
        [85, 17, 86, 88],
    ];

    for (let e = 0; e < 20; e++) {
        const employee = EMPLOYEES[e % EMPLOYEES.length];
        const store = STORES[e % STORES.length];

        PERIODS.forEach((period, pIndex) => {

            items.push({
                employee_id: employee.id,
                store_id: store.id,
                period_id: period.id,
                plan: { amount: 90, unit_id: 'percent' },
                value: { amount: values[e][pIndex], unit_id: 'percent' }
            });
        });
    }

    return items;
};

const efficiencyItems = generateEfficiencyItems();

const generateItemsWithMainAndDetailedPlans = (
    stores,
    groups,
    plans,
    facts,
    valuesMatrix,
    nullStoreValues = null,
    unitIds = { main: "currency", detailed: "pieces" },
    showSign = false,
    factHint = null
) => {
    const items = [];

    const makePlan = (planMain, planDetailed) => [
        { type: "main", amount: planMain, unit_id: unitIds.main, ...(showSign ? { show_sign: true } : {}) },
        { type: "detailed", amount: planDetailed, unit_id: unitIds.detailed, ...(showSign ? { show_sign: true } : {}) }
    ];

    const makeFact = (factMain, factDetailed) => [
        { type: "main", amount: factMain, unit_id: unitIds.main, ...(showSign ? { show_sign: true } : {}) },
        { type: "detailed", amount: factDetailed, unit_id: unitIds.detailed, ...(showSign ? { show_sign: true } : {}) }
    ];

    if (groups.length > 0) {
        groups.forEach((group, idx) => {
            const valueAmount = nullStoreValues?.[idx] ?? 0;
            const item = {
                store_id: null,
                group_id: group,
                plan: makePlan(plans.main, plans.detailed),
                fact: makeFact(facts.main, facts.detailed),
                value: { type: "main", amount: valueAmount, unit_id: "percent" }
            };
            if (factHint) item.fact_hint = factHint;
            items.push(item);
        });

        stores.forEach((storeId, storeIdx) => {
            groups.forEach((group, groupIdx) => {
                const valueAmount = valuesMatrix?.[storeIdx]?.[groupIdx] ?? 0;
                const item = {
                    store_id: storeId,
                    group_id: group,
                    plan: makePlan(plans.main, plans.detailed),
                    fact: makeFact(facts.main, facts.detailed),
                    value: { type: "main", amount: valueAmount, unit_id: "percent" }
                };
                if (factHint) item.fact_hint = factHint;
                items.push(item);
            });
        });
    } else {
        const aggregate = {
            store_id: null,
            group_id: null,
            plan: makePlan(plans.main, plans.detailed),
            fact: makeFact(facts.main, facts.detailed),
            value: { type: "main", amount: nullStoreValues[0], unit_id: "percent" }
        };
        if (factHint) aggregate.fact_hint = factHint;
        items.push(aggregate);

        stores.forEach((storeId, storeIdx) => {
            const valueAmount = valuesMatrix?.[storeIdx] ?? 0;
            const item = {
                store_id: storeId,
                group_id: null,
                plan: makePlan(plans.main, plans.detailed),
                fact: makeFact(facts.main, facts.detailed),
                value: { type: "main", amount: valueAmount, unit_id: "percent" }
            };
            if (factHint) item.fact_hint = factHint;
            items.push(item);
        });
    }

    return items;
};


const plans = { main: 100000000, detailed: 50 };
const facts = { main: 9500000, detailed: 40 };

const mainAndDetailedValuesManager = [
    [120, 83, 94],
    [100, 83, 67],
    [100, 17, 23],
];

const  mainAndDetailedValuesTerritorial = [
    [10],
    [30],
    [60],
    [90],
    [100],
    [120],
    [90],
    [90],
    [90],
    [90],
    [90],
    [90],
    [90],
    [90],
    [90],
]

const itemsWithMainAndDetailedPlansManager = generateItemsWithMainAndDetailedPlans(
    [1, 2, 3],
    ['gpki', 'gp', 'ki'],
    plans,
    facts,
    mainAndDetailedValuesManager,
    [110, 80, 90],
    { main: "currency", detailed: "percent_turnover" },
    false,
    '17 500 ₽ в день'
);

const itemsWithMainAndDetailedPlansTerritorial = generateItemsWithMainAndDetailedPlans(
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    [],
    plans,
    facts,
    mainAndDetailedValuesTerritorial,
    [110, 80, 90],
    { main: "currency", detailed: "percent_turnover" },
    false,
    {
        main: '17 500 ₽ в день',
    }
);

const monthContentDesigner = {
    groups: MONTH_GROUPS,
    widgets: [
        {
            ...calendarWidget
        },
        {
            ...progressWidgetDesigner
        },
        {
            "type_id": "base",
            "name": "Месячный план продаж",
            "group_id": "main",
            labels: LABELS,
            "items": [
                {
                    "store_id": null,
                    "plan": {
                        "amount": 300000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 150000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 10,
                        "unit_id": "percent"
                    }
                }
            ],
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "month",
                        "name": "Бонус за выполнение месячного плана"
                    },
                    {
                        "id": "percent",
                        "name": "Процент от продаж за выполнение плана",
                        "percent_grid": {
                            "items": [
                                {
                                    "plan_threshold": "до 99%",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 99%",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                }
                            ]
                        }
                    }
                ],
                "items": [
                    {
                        "group_id": "month",
                        "items": [
                            {
                                "name": "Выполнение плана 120%",
                                "value": {
                                    "amount": 20000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "percent",
                        "items": [
                            {
                                "name": "Начисленная сумма",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "default"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 20000,
                        "unit_id": "currency"
                    }
                }
            }
        },
        {
            ...leagueStatusDesigner
        },
        {
            ...lineChartDesigner
        },
        {
            ...leagueRating
        },
        {
            ...productGroupsPrices
        },
        {
            ...pieChart
        },
        {
            "type_id": "base",
            "name": "План продаж бутика",
            "group_id": "plan",
            labels: LABELS,
            "items": singleNoGroupItems(10)
        },
        {
            "type_id": "grid",
            "name": "Продажи продукции",
            "group_id": "plan",
            labels: LABELS,
            "items": [
                {
                    "valueHint": "Готовая продукция",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Готовая продукция",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Готовая продукция",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Готовая продукция",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
            ],
            "bonuses": {
                "status_id": "received",
                "groups": [
                    {
                        "id": "percent",
                        "name": "Процент от продаж за выполнение плана",
                        "percent_grid": {
                            "items": [
                                {
                                    "plan_threshold": "Готовая продукция",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "Кровати",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                }
                            ]
                        }
                    },
                ],
                "items": [
                    {
                        "group_id": "percent",
                        "items": [
                            {
                                "name": "Готовая продукция",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            }, {
                                "name": "Кровати",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            },
                        ],
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 20000,
                        "unit_id": "currency"
                    }
                }
            }
        },
        {
            "type_id": "grid",
            "name": "Продажи продукции",
            "group_id": "plan",
            labels: LABELS,
            "items": [
                {
                    "valueHint": "Готовая продукция",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Готовая продукция",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
            ],
            "bonuses": {
                "status_id": "received",
                "groups": [
                    {
                        "id": "percent",
                        "name": "Процент от продаж за выполнение плана",
                        "percent_grid": {
                            "items": [
                                {
                                    "plan_threshold": "Готовая продукция",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "Кровати",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                }
                            ]
                        }
                    },
                ],
                "items": [
                    {
                        "group_id": "percent",
                        "items": [
                            {
                                "name": "Готовая продукция",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            }, {
                                "name": "Кровати",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            },
                        ],
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 20000,
                        "unit_id": "currency"
                    }
                }
            }
        },
    ]
}

const quarterContentDesigner = {
    groups: QUARTER_GROUPS,
    widgets: [
        {
            "type_id": "base",
            "name": "Квартальный план продаж",
            "group_id": "plan",
            labels: LABELS,
            "items": singleNoGroupItems()
        }
    ]
}

const monthContentConsultant = {
    groups: MONTH_GROUPS,
    widgets: [
        {
            ...calendarWidget
        },
        {
            ...progressWidgetConsultant
        },
        {
            "type_id": "base",
            "name": "Месячный план продаж",
            "group_id": "main",
            labels: LABELS,
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "percent",
                        "name": "Процент от продаж за выполнение плана",
                        "percent_grid": {
                            "items": [
                                {
                                    "plan_threshold": "до 80%",
                                    "percent": "4% + подарочный сертификат 15 000",
                                },
                                {
                                    "plan_threshold": "от 81% до 95%",
                                    "percent": {
                                        "amount": 2.5,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 96% до 110%",
                                    "percent": {
                                        "amount": 2.8,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 111%",
                                    "percent": {
                                        "amount": 3.0,
                                        "unit_id": "percent"
                                    }
                                }
                            ],
                            "description": "Процент по чекам со скидкой 30% составляет всегда 2,3% не зависимо от процента выполнения плана"
                        }
                    }
                ],
                "items": [
                    {
                        "group_id": "percent"
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 24558,
                        "unit_id": "currency"
                    }
                }
            },
            items: singleNoGroupItems(10)
        },
        {
            ...leagueStatusConsultant
        },
        {
            ...lineChartConsultant
        },
        {
            ...leagueRating
        },
        {
            ...productGroupsPrices
        },
        {
            ...pieChartConsultant
        },
        {
            "type_id": "base",
            "name": "Средний чек ГП",
            "group_id": "plan",
            labels: LABELS,
            "bonuses": {
                "status_id": "received",
                "groups": [
                    {
                        "id": "average_bill",
                        "name": "Бонус за выполнение 100% нормы среднего чека при выполнении месячного плана"
                    }
                ],
                "items": [
                    {
                        "group_id": "average_bill",
                        "items": [
                            {
                                "name": "Норма от 61%",
                                "value": {
                                    "amount": 5000,
                                    "unit_id": "currency"
                                },
                                "status": "previous"
                            },
                            {
                                "name": "Норма от 101%",
                                "value": {
                                    "amount": 7000,
                                    "unit_id": "currency"
                                },
                                "status": "completed"
                            },
                            {
                                "name": "Норма от 120%",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 7000,
                        "unit_id": "currency"
                    },
                    "extra": [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 10000,
                                "unit_id": "currency"
                            }
                        }
                    ]
                }
            },
            items: singleNoGroupItems(60),
        },
        {
            "type_id": "base",
            "name": "Норма продаж домашней одежды",
            "group_id": "plan",
            labels: LABELS,
            "bonuses": {
                "groups": [
                    {
                        "id": "sales_norm",
                        "name": "Бонус за выполнение ежемесячной нормы продаж домашней одежды"
                    }
                ],
                "items": [
                    {
                        "group_id": "sales_norm",
                        "items": [
                            {
                                "name": "Норма до 70%",
                                "value": {
                                    "amount": 1,
                                    "unit_id": "percent_turnover"
                                },
                                "status": "previous"
                            },
                            {
                                "name": "Норма 80%",
                                "value": {
                                    "amount": 3,
                                    "unit_id": "percent_turnover"
                                },
                                "status": "completed"
                            },
                            {
                                "name": "Норма 90%",
                                "value": {
                                    "amount": 5,
                                    "unit_id": "percent_turnover"
                                },
                                "status": "locked"
                            },
                            {
                                "name": "Норма 100%",
                                "value": {
                                    "amount": 6,
                                    "unit_id": "percent_turnover"
                                },
                                "status": "locked"
                            },
                            {
                                "name": "Норма 110%",
                                "value": {
                                    "amount": 7,
                                    "unit_id": "percent_turnover"
                                },
                                "status": "locked"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 7000,
                        "unit_id": "currency"
                    }
                }
            },
            "items": [
                {
                    "store_id": null,
                    "plan": {
                        "amount": 110,
                        "unit_id": "percent_turnover"
                    },
                    "plan_is_done": true,
                    "fact": {
                        "amount": 60,
                        "unit_id": "percent_turnover"
                    },
                    "value": {
                        "amount": 60,
                        "unit_id": "percent_turnover"
                    }
                }
            ]
        },
        {
            "type_id": "grid",
            "name": "Продажи продукции",
            "group_id": "plan",
            labels: LABELS,
            "items": [
                {
                    "valueHint": "Готовая продукция",
                    "valueSign": "Чек от 500 000 ₽",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Готовая продукция",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Готовая продукция",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Готовая продукция",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
            ],
            "bonuses": {
                "status_id": "received",
                "groups": [
                    {
                        "id": "percent",
                        "name": "Процент от продаж за выполнение плана",
                        "percent_grid": {
                            "items": [
                                {
                                    "plan_threshold": "Готовая продукция",
                                    "note": "Чек от 1 000 00 ₽ без скидок",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "Кровати",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                }
                            ]
                        }
                    },
                ],
                "items": [
                    {
                        "group_id": "percent",
                        "items": [
                            {
                                "name": "Кровати",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            },
                            {
                                "name": "Матрасы",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            },
                            {
                                "name": "Готовая продукция",
                                "sign": "Чек от 500 000 ₽ без скидок",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            }, {
                                "name": "Кровать + матрас",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            },
                        ],
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 20000,
                        "unit_id": "currency"
                    }
                }
            }
        },
        {
            "type_id": "grid",
            "name": "Продажи продукции",
            "group_id": "plan",
            labels: LABELS,
            "items": [
                {
                    "valueHint": "Готовая продукция",
                    "valueSign": "Чек от 500 000 ₽",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровати",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Матрасы",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
                {
                    "valueHint": "Кровать + матрас ",
                    "valueSign": "Чек от 500 000 ₽",
                    "value": {
                        "amount": "1500000",
                        "unit_id": "currency"
                    }
                },
            ],
            "bonuses": {
                "status_id": "received",
                "groups": [
                    {
                        "id": "percent",
                        "name": "Процент от продаж за выполнение плана",
                        "percent_grid": {
                            "items": [
                                {
                                    "plan_threshold": "Готовая продукция",
                                    "note": "Чек от 1 000 00 ₽ без скидок",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "Кровати",
                                    "percent": {
                                        "amount": 4,
                                        "unit_id": "percent"
                                    }
                                }
                            ]
                        }
                    },
                ],
                "items": [
                    {
                        "group_id": "percent",
                        "items": [
                            {
                                "name": "Кровати",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            },
                            {
                                "name": "Матрасы",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            },
                            {
                                "name": "Готовая продукция",
                                "sign": "Чек от 500 000 ₽ без скидок",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            }, {
                                "name": "Кровать + матрас",
                                "value": {
                                    "amount": 8186,
                                    "unit_id": "currency"
                                },
                            },
                        ],
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 20000,
                        "unit_id": "currency"
                    }
                }
            }
        },
    ]
}

const quarterContentConsultant = {
    groups: QUARTER_GROUPS,
    widgets: [
        {
            "type_id": "base",
            "name": "Квартальный план продаж",
            "group_id": "plan",
            labels: LABELS,
            "bonuses": {
                "groups": [
                    {
                        "id": "quarter",
                        "name": "Бонус за выполнение квартального плана"
                    }
                ],
                "items": [
                    {
                        "group_id": "quarter",
                        "items": [
                            {
                                "name": "Выполнение плана 100%",
                                "value": {
                                    "amount": 50000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 0,
                        "unit_id": "currency"
                    }
                },
                "status_id": "in_progress"
            },
            "items": singleNoGroupItems(80)
        },
        {
            "type_id": "base",
            "name": "Емкость чека",
            "group_id": "plan",
            labels: LABELS,
            "bonuses": {
                "groups": [
                    {
                        "id": "check_capacity",
                        "name": "Выполнение нормы 100%"
                    }
                ],
                "items": [
                    {
                        "group_id": "check_capacity",
                        "items": [
                            {
                                "name": "Выполнение плана 100%",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 0,
                        "unit_id": "currency"
                    }
                },
                "status_id": "in_progress"
            },
            "items": [
                {
                    "store_id": null,
                    "group_id": null,
                    "plan": {
                        "amount": 10,
                        "unit_id": "pieces"
                    },
                    "fact": {
                        "amount": 1,
                        "unit_id": "pieces"
                    },
                    "value": {
                        "amount": 99,
                        "unit_id": "percent"
                    }
                }
            ]
        },
        {
            "type_id": "base",
            "name": "Норма продаж продукции",
            "group_id": "plan",
            labels: LABELS,
            "bonuses": {
                "groups": [
                    {
                        "id": "sales_norm",
                        "name": "Бонус за выполнение ежемесячной нормы продаж домашней одежды"
                    }
                ],
                "items": [
                    {
                        "group_id": "sales_norm",
                        "items": [
                            {
                                "name": "КОМПЛЕКС",
                                "value": {
                                    "amount": 20000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            },
                            {
                                "name": "КПБ 100%",
                                "value": {
                                    "amount": 20000,
                                    "unit_id": "currency"
                                },
                                "status": "completed"
                            },
                            {
                                "name": "ОДЕЯЛА 100%",
                                "value": {
                                    "amount": 4000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            },
                            {
                                "name": "ПОДУШКИ 100%",
                                "value": {
                                    "amount": 20000,
                                    "unit_id": "currency"
                                },
                                "status": "completed"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 8000,
                        "unit_id": "currency"
                    },
                    "extra": [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 32000,
                                "unit_id": "currency"
                            }
                        }
                    ]
                },
                "status_id": "in_progress"
            },
            "items": [
                {
                    "store_id": null,
                    "group_id": null,
                    "plan": {
                        "amount": 50,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 30,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 100,
                        "unit_id": "percent"
                    }
                }
            ]
        }
    ]
}

const monthContentManager = {
    groups: MONTH_GROUPS,
    widgets: [
        {
            ...calendarWidget
        },
        {
            ...progressWidgetManager
        },
        {
            "type_id": "base",
            "name": "Месячный план продаж",
            "group_id": "main",
            labels: LABELS,
            "stores_view": "modal",
            "stores_modal_title": "Месячный план продаж, список бутиков",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "percent",
                        "name": "Процент от продаж за выполнение месячного плана",
                        "percent_grid": {
                            "items": [
                                {
                                    "plan_threshold": "до 80%",
                                    "percent": {
                                        "amount": 0.5,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 81% до 89%",
                                    "percent": {
                                        "amount": 0.6,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 90% до 99%",
                                    "percent": {
                                        "amount": 0.7,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 100% до 119%",
                                    "percent": {
                                        "amount": 1,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 120%",
                                    "percent": {
                                        "amount": 1.2,
                                        "unit_id": "percent"
                                    }
                                }
                            ],
                            "description": "Процент по чекам со скидкой 30% составляет всегда 0,5% не зависимо от процента выполнения плана"
                        }
                    }
                ],
                "items": [
                    {
                        "group_id": "percent",
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 24560,
                        "unit_id": "currency"
                    }
                }
            },
            items_group_type: 'product',
            "items": [
                {
                    "store_id": null,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 300000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 150000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 10,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": null,
                    "group_id": "gp",
                    "plan": {
                        "amount": 200000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 1300000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 100,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": null,
                    "group_id": "ki",
                    "plan": {
                        "amount": 5000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 3000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 120,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 300000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 150000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "17 500 ₽ в день",
                    "value": {
                        "amount": 10,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "group_id": "gp",
                    "plan": {
                        "amount": 2000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 24000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "10 500 ₽ в день",
                    "value": {
                        "amount": 10,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "group_id": "ki",
                    "plan": {
                        "amount": 500000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 3000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "18 500 ₽ в день",
                    "value": {
                        "amount": 60,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 5800000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 3000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "19 500 ₽ в день",
                    "value": {
                        "amount": 30,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "group_id": "gp",
                    "plan": {
                        "amount": 500000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 300000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "1 500 ₽ в день",
                    "value": {
                        "amount": 30,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "group_id": "ki",
                    "plan": {
                        "amount": 5300000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 3000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "12 500 ₽ в день",
                    "value": {
                        "amount": 20,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 5800000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 3000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "19 500 ₽ в день",
                    "value": {
                        "amount": 60,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "group_id": "gp",
                    "plan": {
                        "amount": 4500000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 4300000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "1 500 ₽ в день",
                    "value": {
                        "amount": 110,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "group_id": "ki",
                    "plan": {
                        "amount": 9300000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 5000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "12 500 ₽ в день",
                    "value": {
                        "amount": 20,
                        "unit_id": "percent"
                    }
                },
            ],
        },
        {
            ...leagueStatusManager
        },
        {
            ...lineChartManager
        },
        {
            ...leagueRating
        },
        {
            ...productGroupsPrices
        },
        {
            ...pieChartManager
        },
        {
            "type_id": "compare",
            "name": "Общий прирост продаж",
            "group_id": "plan",
            "items_group_type": "product",
            "stores_view": "list",
            "statistic_modal": true,
            "bonuses": {
                "status_id": "in_progress",
                "groups": [{
                    "id": "plan",
                    "name": "Бонус за выполнение плана в магазине без матрасной комнаты"
                }],
                "items": [{
                    "group_id": "plan",
                    "title": "Смоленская - Сенная площадь (Моно)",
                    "items": [{
                        "name": "От 3 матрасов",
                        "value": { "amount": 12000, "unit_id": "currency" },
                        "status": "locked"
                    }, {
                        "name": "От 4 матрасов",
                        "value": { "amount": 17000, "unit_id": "currency" },
                        "status": "locked"
                    }]
                }, {
                    "group_id": "plan",
                    "title": "Ленинский проспект, 60",
                    "items": [{
                        "name": "От 3 матрасов",
                        "value": { "amount": 16000, "unit_id": "currency" },
                        "status": "completed"
                    }, {
                        "name": "От 4 матрасов",
                        "value": { "amount": 18000, "unit_id": "currency" },
                        "status": "locked"
                    }]
                }, {
                    "group_id": "plan",
                    "title": "Мичуринский проспект",
                    "items": [{
                        "name": "От 3 матрасов",
                        "value": { "amount": 13000, "unit_id": "currency" },
                        "status": "previous"
                    }, {
                        "name": "От 4 матрасов",
                        "value": { "amount": 22000, "unit_id": "currency" },
                        "status": "completed"
                    }]
                }],
                "total": {
                    "name": "Всего бонусов",
                    "value": { "amount": 29500, "unit_id": "currency" },
                    "extra": [{
                        "name": "Максимальная сумма",
                        "value": { "amount": 60000, "unit_id": "currency" }
                    }]
                }
            },
            "labels": LABELS,
            "items": [{
                "store_id": null,
                "group_id": "gpki",
                "statistic": [{ "amount": 1100000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 1155000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 20, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 25, "unit_id": "percent", show_sign: true },
                "value": { "amount": 5, "unit_id": "percent", show_sign: true}
            }, {
                "store_id": null,
                "group_id": "gp",
                "statistic": [{ "amount": 1235000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 1210000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 30, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 27, "unit_id": "percent", show_sign: true },
                "value": { "amount": -3, "unit_id": "percent", show_sign: true  }
            }, {
                "store_id": null,
                "group_id": "ki",
                "statistic": [{ "amount": 1235000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 1245000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 50, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 50.8, "unit_id": "percent", show_sign: true },
                "value": { "amount": 0.8, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 1,
                "group_id": "gpki",
                "statistic": [{ "amount": 215000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 180000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 28, "unit_id": "percent", show_sign: true},
                "fact": { "amount": -16, "unit_id": "percent", show_sign: true },
                "value": { "amount": -44, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 1,
                "group_id": "gp",
                "statistic": [{ "amount": 245000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 260000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 21, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 10, "unit_id": "percent", show_sign: true },
                "value": { "amount": -11, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 2,
                "group_id": "gpki",
                "statistic": [{ "amount": 230000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 210000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 22, "unit_id": "percent", show_sign: true },
                "fact": { "amount": -9, "unit_id": "percent", show_sign: true },
                "value": { "amount": -31, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 2,
                "group_id": "gp",
                "statistic": [{ "amount": 260000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 290000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 55, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 61, "unit_id": "percent", show_sign: true},
                "value": { "amount": 6, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 2,
                "group_id": "ki",
                "statistic": [{ "amount": 255000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 245000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 52, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 50, "unit_id": "percent", show_sign: true },
                "value": { "amount": -2, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 3,
                "group_id": "gpki",
                "statistic": [{ "amount": 280000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 310000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 18, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 35, "unit_id": "percent", show_sign: true },
                "value": { "amount": 17, "unit_id": "percent",show_sign: true }
            }, {
                "store_id": 3,
                "group_id": "gp",
                "statistic": [{ "amount": 295000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 280000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 47, "unit_id": "percent", show_sign: true },
                "fact": { "amount": -13, "unit_id": "percent", show_sign: true },
                "value": { "amount": -60, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 3,
                "group_id": "ki",
                "statistic": [{ "amount": 300000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 295000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 85, "unit_id": "percent", show_sign: true },
                "fact": { "amount": -2, "unit_id": "percent", show_sign: true },
                "value": { "amount": -87, "unit_id": "percent",show_sign: true }
            }, {
                "store_id": 4,
                "group_id": "gpki",
                "statistic": [{ "amount": 270000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 290000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 20, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 15, "unit_id": "percent", show_sign: true },
                "value": { "amount": -5, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 4,
                "group_id": "gp",
                "statistic": [{ "amount": 280000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 310000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 45, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 50, "unit_id": "percent", show_sign: true },
                "value": { "amount": 5, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 4,
                "group_id": "ki",
                "statistic": [{ "amount": 290000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 300000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 90, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 92, "unit_id": "percent", show_sign: true },
                "value": { "amount": 2, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 5,
                "group_id": "gpki",
                "statistic": [{ "amount": 265000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 270000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 25, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 30, "unit_id": "percent", show_sign: true },
                "value": { "amount": 5, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 5,
                "group_id": "gp",
                "statistic": [{ "amount": 275000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 280000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 40, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 42, "unit_id": "percent", show_sign: true },
                "value": { "amount": 2, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 5,
                "group_id": "ki",
                "statistic": [{ "amount": 285000000, "unit_id": "currency", "month": 11, "year": 2023 }, { "amount": 295000000, "unit_id": "currency", "month": 11, "year": 2024 }],
                "plan": { "amount": 70, "unit_id": "percent", show_sign: true },
                "fact": { "amount": 72, "unit_id": "percent", show_sign: true },
                "value": { "amount": 2, "unit_id": "percent", show_sign: true }
            }]
        }, {
            "type_id": "compare",
            "name": "Прирост L2L",
            "group_id": "plan",
            "items_group_type": "product",
            "stores_view": "list",
            "stores_modal_title": "Выбор магазинов для анализа",
            "labels": {
                ...LABELS,
                plan: "2023",
                fact: "2024",
            },
            "items": [{
                "store_id": null,
                "group_id": "gpki",
                "plan": { "amount": 1210000000, "unit_id": "currency" },
                "fact": { "amount": 1235000000, "unit_id": "currency" },
                "value": { "amount": 2, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": null,
                "group_id": "gp",
                "plan": { "amount": 1355000000, "unit_id": "currency" },
                "fact": { "amount": 1400000000, "unit_id": "currency" },
                "value": { "amount": 1, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": null,
                "group_id": "ki",
                "plan": { "amount": 1375000000, "unit_id": "currency" },
                "fact": { "amount": 1385000000, "unit_id": "currency" },
                "value": { "amount": -1, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 1,
                "group_id": "gpki",
                "plan": { "amount": 215000000, "unit_id": "currency" },
                "fact": { "amount": 210000000, "unit_id": "currency" },
                "value": { "amount": -30, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 1,
                "group_id": "gp",
                "plan": { "amount": 245000000, "unit_id": "currency" },
                "fact": { "amount": 260000000, "unit_id": "currency" },
                "value": { "amount": -11, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 1,
                "group_id": "ki",
                "plan": { "amount": 240000000, "unit_id": "currency" },
                "fact": { "amount": 260000000, "unit_id": "currency" },
                "value": { "amount": 3, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 2,
                "group_id": "gpki",
                "plan": { "amount": 230000000, "unit_id": "currency" },
                "fact": { "amount": 235000000, "unit_id": "currency" },
                "value": { "amount": -17, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 2,
                "group_id": "gp",
                "plan": { "amount": 260000000, "unit_id": "currency" },
                "fact": { "amount": 265000000, "unit_id": "currency" },
                "value": { "amount": 2, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 2,
                "group_id": "ki",
                "plan": { "amount": 255000000, "unit_id": "currency" },
                "fact": { "amount": 250000000, "unit_id": "currency" },
                "value": { "amount": -4, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 3,
                "group_id": "gpki",
                "plan": { "amount": 280000000, "unit_id": "currency" },
                "fact": { "amount": 290000000, "unit_id": "currency" },
                "value": { "amount": 7, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 3,
                "group_id": "gp",
                "plan": { "amount": 295000000, "unit_id": "currency" },
                "fact": { "amount": 285000000, "unit_id": "currency" },
                "value": { "amount": -52, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 3,
                "group_id": "ki",
                "plan": { "amount": 300000000, "unit_id": "currency" },
                "fact": { "amount": 295000000, "unit_id": "currency" },
                "value": { "amount": -87, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 4,
                "group_id": "gpki",
                "plan": { "amount": 270000000, "unit_id": "currency" },
                "fact": { "amount": 280000000, "unit_id": "currency" },
                "value": { "amount": -5, "unit_id": "percent",show_sign: true }
            }, {
                "store_id": 4,
                "group_id": "gp",
                "plan": { "amount": 280000000, "unit_id": "currency" },
                "fact": { "amount": 300000000, "unit_id": "currency" },
                "value": { "amount": 5, "unit_id": "percent" , show_sign: true}
            }, {
                "store_id": 4,
                "group_id": "ki",
                "plan": { "amount": 290000000, "unit_id": "currency" },
                "fact": { "amount": 300000000, "unit_id": "currency" },
                "value": { "amount": 2, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 5,
                "group_id": "gpki",
                "plan": { "amount": 265000000, "unit_id": "currency" },
                "fact": { "amount": 270000000, "unit_id": "currency" },
                "value": { "amount": 5, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 5,
                "group_id": "gp",
                "plan": { "amount": 275000000, "unit_id": "currency" },
                "fact": { "amount": 280000000, "unit_id": "currency" },
                "value": { "amount": 2, "unit_id": "percent", show_sign: true }
            }, {
                "store_id": 5,
                "group_id": "ki",
                "plan": { "amount": 285000000, "unit_id": "currency" },
                "fact": { "amount": 295000000, "unit_id": "currency" },
                "value": { "amount": 2, "unit_id": "percent", show_sign: true }
            }]
        },
        {
            "type_id": "base",
            "name": "План продаж по матрасам",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "plan",
                        "name": "Бонус за выполнение плана в магазине без матрасной комнаты"
                    }
                ],
                "items": [
                    {
                        "group_id": "plan",
                        "title": "Смоленская - Сенная площадь (Моно)",
                        "items": [
                            {
                                "name": "От 3 матрасов",
                                "value": {
                                    "amount": 15000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            },
                            {
                                "name": "От 4 матрасов",
                                "value": {
                                    "amount": 20000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "plan",
                        "title": "Ленинский проспект, 60",
                        "items": [
                            {
                                "name": "От 3 матрасов",
                                "value": {
                                    "amount": 15000,
                                    "unit_id": "currency"
                                },
                                "status": "completed"
                            },
                            {
                                "name": "От 4 матрасов",
                                "value": {
                                    "amount": 20000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "plan",
                        "title": "Мичуринский проспект",
                        "items": [
                            {
                                "name": "От 3 матрасов",
                                "value": {
                                    "amount": 15000,
                                    "unit_id": "currency"
                                },
                                "status": "previous"
                            },
                            {
                                "name": "От 4 матрасов",
                                "value": {
                                    "amount": 20000,
                                    "unit_id": "currency"
                                },
                                "status": "completed"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 35000,
                        "unit_id": "currency"
                    },
                    "extra": [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 60000,
                                "unit_id": "currency"
                            }
                        }
                    ]
                }
            },
            "items": [
                {
                    "store_id": null,
                    "plan": {
                        "amount": 90,
                        "unit_id": "pieces"
                    },
                    "fact": {
                        "amount": 60,
                        "unit_id": "pieces"
                    },
                    "value": {
                        "amount": 60,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "plan": {
                        "amount": 15,
                        "unit_id": "pieces"
                    },
                    "fact": {
                        "amount": 15,
                        "unit_id": "pieces"
                    },
                    "value": {
                        "amount": 30,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "plan": {
                        "amount": 15,
                        "unit_id": "pieces"
                    },
                    "fact": {
                        "amount": 30,
                        "unit_id": "pieces"
                    },
                    "value": {
                        "amount": 100,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "plan": {
                        "amount": 15,
                        "unit_id": "pieces"
                    },
                    "fact": {
                        "amount": 15,
                        "unit_id": "pieces"
                    },
                    "value": {
                        "amount": 90,
                        "unit_id": "percent"
                    }
                }
            ]
        },
        {
            "type_id": "base",
            "name": "Конверсия продаж",
            "group_id": "plan",
            "stores_view": "list",
            labels: LABELS,
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "sales",
                        "name": "Бонус за выполнение плана по конверсии продаж"
                    }
                ],
                "items": [
                    {
                        "group_id": "sales",
                        "title": "329 МСК. Центральный Детский Мир",
                        "items": [
                            {
                                "name": "Выполнение плана 100%",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "sales",
                        "title": "134 КРД. Красная площадь Краснодар",
                        "items": [
                            {
                                "name": "Выполнение плана 100%",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "completed"
                            }
                        ]
                    },
                    {
                        "group_id": "sales",
                        "title": "329 МСК. Центральный Детский Мир",
                        "items": [
                            {
                                "name": "Выполнение плана 100%",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 10000,
                        "unit_id": "currency"
                    },
                    "extra": [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 30000,
                                "unit_id": "currency"
                            }
                        }
                    ]
                },
            },
            items_group_type: "product",
            "items": [
                {
                    "store_id": null,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 20,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 10,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 10,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": null,
                    "group_id": "gp",
                    "plan": {
                        "amount": 30,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 40,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 50,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": null,
                    "group_id": "ki",
                    "plan": {
                        "amount": 60,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 70,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 30,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 30,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 15,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 60,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "group_id": "gp",
                    "plan": {
                        "amount": 20,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 25,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 15,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "group_id": "ki",
                    "plan": {
                        "amount": 20,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 30,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 35,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 20,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 30,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 100,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "group_id": "gp",
                    "plan": {
                        "amount": 50,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 30,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 40,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "group_id": "ki",
                    "plan": {
                        "amount": 50,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 30,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 60,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 20,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 30,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 90,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "group_id": "gp",
                    "plan": {
                        "amount": 45,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 30,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 110,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "group_id": "ki",
                    "plan": {
                        "amount": 90,
                        "unit_id": "percent"
                    },
                    "fact": {
                        "amount": 50,
                        "unit_id": "percent"
                    },
                    "value": {
                        "amount": 20,
                        "unit_id": "percent"
                    }
                },
            ],
        },
        {
            type_id: "base",
            "name": "План КИ",
            "group_id": "plan",
            "stores_view": "list",
            labels: LABELS,
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "ki",
                        "name": "Бонус за выполнение плана продаж по продукции КИ"
                    }
                ],
                "items": [
                    {
                        "group_id": "ki",
                        "title": "329 МСК. Центральный Детский Мир",
                        "items": [
                            {
                                "name": "Выполнение плана 100%",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            },
                            {
                                "name": "Выполнение плана 100%",
                                "value": {
                                    "amount": 25000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "ki",
                        "title": "134 КРД. Красная площадь Краснодар",
                        "items": [
                            {
                                "name": "Выполнение плана 100%",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "completed"
                            },
                            {
                                "name": "Выполнение плана 120%",
                                "value": {
                                    "amount": 25000,
                                    "unit_id": "currency"
                                },
                                "status": "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "ki",
                        "title": "329 МСК. Центральный Детский Мир",
                        "items": [
                            {
                                "name": "Выполнение плана 100%",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "previous"
                            },
                            {
                                "name": "Выполнение плана 120%",
                                "value": {
                                    "amount": 10000,
                                    "unit_id": "currency"
                                },
                                "status": "completed"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 35000,
                        "unit_id": "currency"
                    },
                    "extra": [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 75000,
                                "unit_id": "currency"
                            }
                        }
                    ]
                },
            },
            items_group_type: "product",
            "items": [
                {
                    "store_id": null,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 300000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 160000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "17 500 ₽ в день",
                    "value": {
                        "amount": 10,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": null,
                    "group_id": "gp",
                    "plan": {
                        "amount": 300000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 150000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "10 500 ₽ в день",
                    "value": {
                        "amount": 50,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": null,
                    "group_id": "ki",
                    "plan": {
                        "amount": 300000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 150000000,
                        "unit_id": "currency"
                    },
                    "fact_hint": "12 500 ₽ в день",
                    "value": {
                        "amount": 30,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 300000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 150000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 60,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "group_id": "gp",
                    "plan": {
                        "amount": 200000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 160000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 15,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 1,
                    "group_id": "ki",
                    "plan": {
                        "amount": 700000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 60000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 35,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 900000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 40000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 100,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "group_id": "gp",
                    "plan": {
                        "amount": 200000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 10000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 40,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 2,
                    "group_id": "ki",
                    "plan": {
                        "amount": 500000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 30000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 60,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "group_id": "gpki",
                    "plan": {
                        "amount": 70000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 8000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 90,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "group_id": "gp",
                    "plan": {
                        "amount": 90000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 60000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 110,
                        "unit_id": "percent"
                    }
                },
                {
                    "store_id": 3,
                    "group_id": "ki",
                    "plan": {
                        "amount": 8000000,
                        "unit_id": "currency"
                    },
                    "fact": {
                        "amount": 2000000,
                        "unit_id": "currency"
                    },
                    "value": {
                        "amount": 20,
                        "unit_id": "percent"
                    }
                },
            ],
        }
    ]
}

const quarterContentManager = {
    groups: QUARTER_GROUPS,
    widgets: [
        {
            "type_id": "base",
            "name": "Квартальный план продаж",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "quarter",
                        "name": "Бонус за выполнение квартального плана продаж",
                    }
                ],
                "items": [
                    {
                        "group_id": "quarter",
                        "title": "126 НСК. Большая Медведица",
                        items: [
                            {
                                name: "Выполнение плана 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                            {
                                name: "Выполнение плана 120%",
                                value: {
                                    amount: 20000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "quarter",
                        "title": "134 КРД. Красная площадь Краснодар",
                        items: [
                            {
                                name: "Выполнение плана 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            },
                            {
                                name: "Выполнение плана 120%",
                                value: {
                                    amount: 20000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "quarter",
                        "title": "134 КРД. Красная площадь Краснодар",
                        items: [
                            {
                                name: "Выполнение плана 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "previous"
                            },
                            {
                                name: "Выполнение плана 120%",
                                value: {
                                    amount: 20000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 30000,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 60000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items_group_type: "product",
            items: generateItemsWithStoresAndGroups(
                [1, 2, 3],
                groups,
                30000000,
                1600000,
                values,
                null,
                "currency",
                "percent" ,
                false
            )
        },
        {
            "type_id": "base",
            "name": "Средний чек",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "average_bill",
                        "name": "Бонус за выполнение нормы по сумме среднего чека",
                    }
                ],
                "items": [
                    {
                        "group_id": "average_bill",
                        "title": "126 НСК. Большая Медведица",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                            {
                                name: "Норма КИ 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "average_bill",
                        "title": "134 КРД. Красная площадь Краснодар",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            },
                            {
                                name: "Норма КИ 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "average_bill",
                        "title": "134 КРД. Красная площадь Краснодар",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "previous"
                            },
                            {
                                name: "Норма КИ 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 30000,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 40000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items_group_type: "product",
            items: generateItemsWithStoresAndGroups(
                [1, 2, 3],
                ['gp', 'ki'],
                30000,
                16000,
                values,
                null,
                "currency",
                "percent" ,
                false
            )
        },
        {
            "type_id": "base",
            "name": "Емкость чека",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "check_capacity",
                        "name": "Бонус за выполнение нормы по емкости чека",
                    }
                ],
                "items": [
                    {
                        "group_id": "check_capacity",
                        "title": "126 НСК. Большая Медведица",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "check_capacity",
                        "title": "134 КРД. Красная площадь Краснодар",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            }
                        ]
                    },
                    {
                        "group_id": "check_capacity",
                        "title": "134 КРД. Красная площадь Краснодар",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "previous"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 10000,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 30000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items_group_type: "product",
            items: generateItemsWithStoresAndGroups(
                [1, 2, 3],
                groups,
                10,
                6,
                values,
                null,
                "pieces_per_check",
                "percent" ,
                false
            )
        },
        {
            "type_id": "base",
            "name": "Норма продаж продукции",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "sales_rate",
                        "name": "Бонус за выполнение нормы продаж продукции",
                    }
                ],
                "items": [
                    {
                        "group_id": "sales_rate",
                        items: [
                            {
                                name: "КОМПЛЕКС",
                                value: {
                                    amount: 50000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                            {
                                name: "КПБ 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            }, {
                                name: "ОДЕЯЛА 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                            {
                                name: "ПОДУШКИ 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 20000,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 50000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items_group_type: "product",
            items: generateItemsWithStoresAndGroups(
                [1, 2, 3],
                groups,
                10,
                6,
                values,
                null,
                "percent_turnover",
                "percent" ,
                false
            )
        },
        {
            "type_id": "base",
            "name": "Норма продаж домашней одежды",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "sales_rate",
                        "name": "Бонус за выполнение нормы продаж 10% от оборота бутика",
                    }
                ],
                "items": [
                    {
                        "group_id": "sales_rate",
                        title: "126 НСК. Большая Медведица",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 15000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    },
                    {
                        "group_id": "sales_rate",
                        title: "134 КРД. Красная площадь Краснодар",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 15000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            }
                        ]
                    },
                    {
                        "group_id": "sales_rate",
                        title: "329 МСК. Центральный Детский Мир",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 15000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 15000,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 45000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items_group_type: "product",
            items: itemsWithMainAndDetailedPlansManager
        },
        {
            "type_id": "base",
            "name": "План сотрудников бутиков",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            items_group_type: "positions",
            items: generateItemsWithStoresAndGroups(
                [1, 2, 3],
                ["designer", "consultant", "manager"],
                85,
                60,
                values,
                null,
                "percent",
                "percent" ,
                false
            ),
            efficiency: {
                items: efficiencyItems
            }
        },
    ]
}

const monthContentTerritorial = {
    groups: MONTH_GROUPS,
    widgets: [
        {
            ...calendarWidget
        },
        {
            ...progressWidgetTerritorial
        },
        {
            "type_id": "base",
            "name": "Месячный план продаж",
            "group_id": "main",
            labels: LABELS,
            "stores_view": "modal",
            "stores_modal_title": "Месячный план продаж, список бутиков",
            "bonuses": {
                "status_id": "received",
                "groups": [
                    {
                        "id": "percent",
                        "name": "Процент от продаж за выполнение месячного плана",
                        "percent_grid": {
                            "items": [
                                {
                                    "plan_threshold": "до 80%",
                                    "percent": {
                                        "amount": 0.14,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 80% до 99%",
                                    "percent": {
                                        "amount": 0.15,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 90% до 100%",
                                    "percent": {
                                        "amount": 0.16,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 100% до 110%",
                                    "percent": {
                                        "amount": 0.18,
                                        "unit_id": "percent"
                                    }
                                },
                                {
                                    "plan_threshold": "от 120%",
                                    "percent": {
                                        "amount": 0.2,
                                        "unit_id": "percent"
                                    }
                                }
                            ]
                        }
                    }
                ],
                "items": [
                    {
                        "group_id": "percent",
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 24560,
                        "unit_id": "currency"
                    }
                }
            },
            "items_group_type": "product",
            items: itemsWithStoresAndGroups
        },
        {
            ...leagueStatusTerritorial
        },
        {
            ...lineChartTerritorial
        },
        {
            ...leagueRating
        },
        {
            ...productGroupsPrices
        },
        {
            ...pieChartTerritorial
        },
        {
            "type_id": "base",
            "name": "Выполнение плана КИ",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "ki",
                        "name": "Бонус за выполнение плана КИ",
                    }
                ],
                "items": [
                    {
                        "group_id": "ki",
                        "title": "Выплата в рамках всех бутиков",
                        items: [
                            {
                                name: "1 уровень, выполнение плана 90%",
                                value: {
                                    amount: 15000,
                                    unit_id: "currency"
                                },
                                status: "previous"
                            },
                            {
                                name: "2 уровень, выполнение плана 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            },
                            {
                                name: "3 уровень, выполнение плана 110%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 20000,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 25000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items: itemsWithStores,
        },
        {
            "type_id": "base",
            "name": "Продажа товаров Outlet",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "outlet",
                        "name": "Бонус за выполнение плана по продаже товаров Outlet",
                    }
                ],
                "items": [
                    {
                        "group_id": "outlet",
                        "title": "Выплата в рамках всех бутиков",
                        items: [
                            {
                                name: "1 уровень, выполнение плана 90%",
                                value: {
                                    amount: 5000,
                                    unit_id: "currency"
                                },
                                status: "previous"
                            },
                            {
                                name: "2 уровень, выполнение плана 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            },
                            {
                                name: "3 уровень, выполнение плана 110%",
                                value: {
                                    amount: 15000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 10000,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 15000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items: itemsWithStores,
        },
        {
            "type_id": "base",
            "name": "Средний чек ГП",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "average_bill",
                        "name": "Бонус за выполнение плана по среднему чеку",
                    }
                ],
                "items": [
                    {
                        "group_id": "average_bill",
                        "title": "Выплата в рамках всех бутиков",
                        items: [
                            {
                                name: "Выполнение плана 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "previous"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 0,
                        "unit_id": "currency"
                    }
                }
            },
            items_group_type: "product",
            items: itemsWithStoresAndGroups,
        },
        {
            "type_id": "base",
            "name": "Емкость чека ГП",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "check",
                        "name": "Бонус за выполнение плана по емкости чека",
                    }
                ],
                "items": [
                    {
                        "group_id": "check",
                        items: [
                            {
                                name: "Выполнение плана 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 0,
                        "unit_id": "currency"
                    }
                }
            },
            items: createItemsWithStores(
                [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                10,
                5,
                "pieces_per_check",
                [60, 30, 60, 90, 100, 120, 90, 90, 90, 90, 90, 90, 90, 10, 10]
            )
        },
        {
            "type_id": "base",
            "name": "Конверсия продаж",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "check",
                        "name": "Бонус за выполнение плана по емкости чека",
                    }
                ],
                "items": [
                    {
                        "group_id": "check",
                        title: "Выплата в рамках всех бутиков",
                        items: [
                            {
                                name: "Выполнение плана 100%",
                                value: {
                                    amount: 15000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 0,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 15000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items_group_type: "product",
            items: generateItemsWithStoresAndGroups(
                stores,
                groups,
                5,
                2,
                values,
                null,
                "percent_target",
                "percent",
                true
            ),
        }
    ]
}

const quarterContentTerritorial = {
    groups: QUARTER_GROUPS,
    widgets: [
        {
            "type_id": "base",
            "name": "Квартальный план продаж",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            items_group_type: "product",
            items: generateItemsWithStoresAndGroups(
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                groups,
                30000000,
                1600000,
                values,
                "17 500 ₽ в день",
                "currency",
                "percent" ,
                false
            )
        },
        {
            "type_id": "base",
            "name": "Норма продаж продукции",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "sales_rate",
                        "name": "Бонус за выполнение нормы продаж продукции",
                    }
                ],
                "items": [
                    {
                        "group_id": "sales_rate",
                        items: [
                            {
                                name: "КОМПЛЕКС",
                                value: {
                                    amount: 50000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                            {
                                name: "КПБ 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            }, {
                                name: "ОДЕЯЛА 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                            {
                                name: "ПОДУШКИ 100%",
                                value: {
                                    amount: 10000,
                                    unit_id: "currency"
                                },
                                status: "completed"
                            }
                        ]
                    }
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 20000,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 80000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items_group_type: "assortment",
            items: generateItemsWithStoresAndGroups(
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                ["set", "bed_linen", "blankets", "pillows"],
                50,
                30,
                values,
                null,
                "percent_turnover",
                "percent" ,
                false
            )
        },
        {
            "type_id": "base",
            "name": "Норма продаж домашней одежды",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "home_clothes",
                        "name": "Бонус за выполнение нормы продаж домашней одежды",
                    }
                ],
                "items": [
                    {
                        "group_id": "home_clothes",
                        items: [
                            {
                                name: "Норма ГП 100%",
                                value: {
                                    amount: 15000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                            {
                                name: "Норма ГП 110%",
                                value: {
                                    amount: 15000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    },
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 0,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 20000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items_group_type: "product",
            items: itemsWithMainAndDetailedPlansTerritorial
        },
        {
            "type_id": "base",
            "name": "План сотрудников куста",
            "group_id": "plan",
            labels: LABELS,
            "stores_view": "list",
            "bonuses": {
                "status_id": "in_progress",
                "groups": [
                    {
                        "id": "employees_plan",
                        "name": "Бонус за выполнение нормы плана сотрудниками куста",
                    }
                ],
                "items": [
                    {
                        "group_id": "employees_plan",
                        items: [
                            {
                                name: "Консультанты 85%",
                                value: {
                                    amount: 30000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                            {
                                name: "Дизайнеры 90%",
                                value: {
                                    amount: 30000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            },
                            {
                                name: "Руководитель бутика 100%",
                                value: {
                                    amount: 30000,
                                    unit_id: "currency"
                                },
                                status: "locked"
                            }
                        ]
                    },
                ],
                "total": {
                    "name": "Всего бонусов",
                    "value": {
                        "amount": 0,
                        "unit_id": "currency"
                    },
                    extra: [
                        {
                            "name": "Максимальная сумма",
                            "value": {
                                "amount": 60000,
                                "unit_id": "currency"
                            },
                        }
                    ]
                }
            },
            items_group_type: "positions",
            items: generateItemsWithStoresAndGroups(
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                ["designer", "consultant", "manager"],
                85,
                60,
                values,
                null,
                "percent",
                "percent" ,
                false
            ),
            efficiency: {
                items: efficiencyItems
            }
        },
    ]
}

const yearContentTerritorial = {
    groups: YEAR_GROUPS,
    widgets: [{
        'type_id': 'compare',
        'name': 'Прирост к прошлому году',
        'group_id': 'plan',
        'items_group_type': 'product',
        'stores_view': 'list',
        'stores_modal_title': 'Выбор магазинов для анализа',
        labels: {
            ...LABELS,
            plan: "2023",
            fact: "2024",
        },
        "items": [{
            "store_id": null,
            "group_id": "gpki",
            "plan": { "amount": 1000000000, "unit_id": "currency" },
            "fact": { "amount": 950000000, "unit_id": "currency" },
            "value": { "amount": -5, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": null,
            "group_id": "gp",
            "plan": { "amount": 1120000000, "unit_id": "currency" },
            "fact": { "amount": 1070000000, "unit_id": "currency" },
            "value": { "amount": -4.46, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": null,
            "group_id": "ki",
            "plan": { "amount": 1205000000, "unit_id": "currency" },
            "fact": { "amount": 1230000000, "unit_id": "currency" },
            "value": { "amount": 2.07, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 1,
            "group_id": "gpki",
            "plan": { "amount": 200000000, "unit_id": "currency" },
            "fact": { "amount": 180000000, "unit_id": "currency" },
            "value": { "amount": -10, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 1,
            "group_id": "gp",
            "plan": { "amount": 250000000, "unit_id": "currency" },
            "fact": { "amount": 230000000, "unit_id": "currency" },
            "value": { "amount": -8, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 1,
            "group_id": "ki",
            "plan": { "amount": 220000000, "unit_id": "currency" },
            "fact": { "amount": 240000000, "unit_id": "currency" },
            "value": { "amount": 9.09, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 2,
            "group_id": "gpki",
            "plan": { "amount": 180000000, "unit_id": "currency" },
            "fact": { "amount": 190000000, "unit_id": "currency" },
            "value": { "amount": 5.56, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 2,
            "group_id": "gp",
            "plan": { "amount": 260000000, "unit_id": "currency" },
            "fact": { "amount": 250000000, "unit_id": "currency" },
            "value": { "amount": -3.85, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 2,
            "group_id": "ki",
            "plan": { "amount": 240000000, "unit_id": "currency" },
            "fact": { "amount": 235000000, "unit_id": "currency" },
            "value": { "amount": -2.08, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 3,
            "group_id": "gpki",
            "plan": { "amount": 200000000, "unit_id": "currency" },
            "fact": { "amount": 210000000, "unit_id": "currency" },
            "value": { "amount": 5, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 3,
            "group_id": "gp",
            "plan": { "amount": 210000000, "unit_id": "currency" },
            "fact": { "amount": 200000000, "unit_id": "currency" },
            "value": { "amount": -4.76, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 3,
            "group_id": "ki",
            "plan": { "amount": 240000000, "unit_id": "currency" },
            "fact": { "amount": 245000000, "unit_id": "currency" },
            "value": { "amount": 2.08, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 4,
            "group_id": "gpki",
            "plan": { "amount": 210000000, "unit_id": "currency" },
            "fact": { "amount": 200000000, "unit_id": "currency" },
            "value": { "amount": -4.76, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 4,
            "group_id": "gp",
            "plan": { "amount": 240000000, "unit_id": "currency" },
            "fact": { "amount": 250000000, "unit_id": "currency" },
            "value": { "amount": 4.17, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 4,
            "group_id": "ki",
            "plan": { "amount": 250000000, "unit_id": "currency" },
            "fact": { "amount": 260000000, "unit_id": "currency" },
            "value": { "amount": 4, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 5,
            "group_id": "gpki",
            "plan": { "amount": 210000000, "unit_id": "currency" },
            "fact": { "amount": 210000000, "unit_id": "currency" },
            "value": { "amount": 0, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 5,
            "group_id": "gp",
            "plan": { "amount": 250000000, "unit_id": "currency" },
            "fact": { "amount": 260000000, "unit_id": "currency" },
            "value": { "amount": 4, "unit_id": "percent", show_sign: true }
        }, {
            "store_id": 5,
            "group_id": "ki",
            "plan": { "amount": 260000000, "unit_id": "currency" },
            "fact": { "amount": 265000000, "unit_id": "currency" },
            "value": { "amount": 1.92, "unit_id": "percent", show_sign: true }
        }],
    }],
};

const yearContentManager = {
    groups: YEAR_GROUPS,
    widgets: [{
        type_id: "compare",
        name: "Общий прирост продаж",
        group_id: "plan",
        items_group_type: "product",
        stores_view: "list",
        statistic_modal: true,
        labels: LABELS,
        items: [{
            store_id: null,
            group_id: "gpki",
            statistic: [{ amount: 1270000000, unit_id: "currency", year: 2023 }, { amount: 1315000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 12, unit_id: "percent", show_sign: true },
            fact: { amount: 3.94, unit_id: "percent", show_sign: true },
            value: { amount: -8.06, unit_id: "percent", show_sign: true }
        }, {
            store_id: null,
            group_id: "gp",
            statistic: [{ amount: 1280000000, unit_id: "currency", year: 2023 }, { amount: 1315000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 15, unit_id: "percent", show_sign: true },
            fact: { amount: 2.73, unit_id: "percent", show_sign: true },
            value: { amount: -12.27, unit_id: "percent", show_sign: true }
        }, {
            store_id: null,
            group_id: "ki",
            statistic: [{ amount: 1040000000, unit_id: "currency", year: 2023 }, { amount: 1090000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 4.81, unit_id: "percent", show_sign: true },
            value: { amount: -5.19, unit_id: "percent", show_sign: true }
        }, {
            store_id: 1,
            group_id: "gpki",
            statistic: [{ amount: 240000000, unit_id: "currency", year: 2023 }, { amount: 250000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 4.17, unit_id: "percent", show_sign: true },
            value: { amount: -5.83, unit_id: "percent", show_sign: true }
        }, {
            store_id: 1,
            group_id: "gp",
            statistic: [{ amount: 260000000, unit_id: "currency", year: 2023 }, { amount: 280000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 12, unit_id: "percent", show_sign: true },
            fact: { amount: 7.69, unit_id: "percent", show_sign: true },
            value: { amount: -4.31, unit_id: "percent", show_sign: true }
        }, {
            store_id: 1,
            group_id: "ki",
            statistic: [{ amount: 250000000, unit_id: "currency", year: 2023 }, { amount: 270000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 8, unit_id: "percent", show_sign: true },
            value: { amount: -2, unit_id: "percent", show_sign: true }
        }, {
            store_id: 2,
            group_id: "gpki",
            statistic: [{ amount: 220000000, unit_id: "currency", year: 2023 }, { amount: 240000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 8, unit_id: "percent", show_sign: true },
            fact: { amount: 9.09, unit_id: "percent", show_sign: true },
            value: { amount: 1.09, unit_id: "percent", show_sign: true }
        }, {
            store_id: 2,
            group_id: "gp",
            statistic: [{ amount: 270000000, unit_id: "currency", year: 2023 }, { amount: 290000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 7.41, unit_id: "percent", show_sign: true },
            value: { amount: -2.59, unit_id: "percent", show_sign: true }
        }, {
            store_id: 2,
            group_id: "ki",
            statistic: [{ amount: 260000000, unit_id: "currency", year: 2023 }, { amount: 290000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 12, unit_id: "percent", show_sign: true },
            fact: { amount: 11.54, unit_id: "percent", show_sign: true },
            value: { amount: -0.46, unit_id: "percent", show_sign: true }
        }, {
            store_id: 3,
            group_id: "gpki",
            statistic: [{ amount: 230000000, unit_id: "currency", year: 2023 }, { amount: 225000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 5, unit_id: "percent", show_sign: true },
            fact: { amount: -2.17, unit_id: "percent", show_sign: true },
            value: { amount: -7.17, unit_id: "percent", show_sign: true }
        }, {
            store_id: 3,
            group_id: "gp",
            statistic: [{ amount: 260000000, unit_id: "currency", year: 2023 }, { amount: 270000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 3.85, unit_id: "percent", show_sign: true },
            value: { amount: -6.15, unit_id: "percent",show_sign: true }
        }, {
            store_id: 3,
            group_id: "ki",
            statistic: [{ amount: 240000000, unit_id: "currency", year: 2023 }, { amount: 250000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 4.17, unit_id: "percent", show_sign: true },
            value: { amount: -5.83, unit_id: "percent", show_sign: true }
        }, {
            store_id: 4,
            group_id: "gpki",
            statistic: [{ amount: 250000000, unit_id: "currency", year: 2023 }, { amount: 260000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 4, unit_id: "percent", show_sign: true },
            value: { amount: -6, unit_id: "percent", show_sign: true }
        }, {
            store_id: 4,
            group_id: "gp",
            statistic: [{ amount: 270000000, unit_id: "currency", year: 2023 }, { amount: 280000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 8, unit_id: "percent", show_sign: true },
            fact: { amount: 3.70, unit_id: "percent", show_sign: true },
            value: { amount: -4.30, unit_id: "percent", show_sign: true }
        }, {
            store_id: 4,
            group_id: "ki",
            statistic: [{ amount: 260000000, unit_id: "currency", year: 2023 }, { amount: 270000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 3.85, unit_id: "percent", show_sign: true },
            value: { amount: -6.15, unit_id: "percent", show_sign: true }
        }, {
            store_id: 5,
            group_id: "gpki",
            statistic: [{ amount: 250000000, unit_id: "currency", year: 2023 }, { amount: 255000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 8, unit_id: "percent", show_sign: true },
            fact: { amount: 2, unit_id: "percent", show_sign: true },
            value: { amount: -6, unit_id: "percent", show_sign: true }
        }, {
            store_id: 5,
            group_id: "gp",
            statistic: [{ amount: 260000000, unit_id: "currency", year: 2023 }, { amount: 280000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 7.69, unit_id: "percent", show_sign: true },
            value: { amount: -2.31, unit_id: "percent", show_sign: true }
        }, {
            store_id: 5,
            group_id: "ki",
            statistic: [{ amount: 280000000, unit_id: "currency", year: 2023 }, { amount: 300000000, unit_id: "currency", year: 2024 }],
            plan: { amount: 10, unit_id: "percent", show_sign: true },
            fact: { amount: 7.14, unit_id: "percent", show_sign: true },
            value: { amount: -2.86, unit_id: "percent", show_sign: true }
        }]
    }],
};

const bonusesDesigner = {
    groups: [
        {
            id: "month",
            total: {
                name: "Итого за месяц",
                value: {
                    amount: 0,
                    unit_id: "currency"
                }
            }
        }
    ],
    items: [
        {
            group_id: "month",
            name: "Процент от продаж",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение месячного плана",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Процент от продаж готовой продукции",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        }
    ],
    total: {
        name: "Всего бонусов",
        value: {
            amount: 0,
            unit_id: "currency"
        }
    }
}

const bonusesConsultant = {
    groups: [
        {
            id: "month",
            total: {
                name: "Итого за месяц",
                value: {
                    amount: 0,
                    unit_id: "currency"
                }
            }
        },
        {
            id: "quarter",
            total: {
                name: "Итого за квартал",
                value: {
                    amount: 0,
                    unit_id: "currency"
                }
            }
        }
    ],
    items: [
        {
            group_id: "month",
            name: "Процент от продаж",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение нормы среднего чека",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение нормы продаж домашней одежды",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Процент от продаж готовой продукции",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение квартального плана",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы емкости чека",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы процента продаж продукции",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        }
    ],
    total: {
        name: "Всего бонусов",
        value: {
            amount: 0,
            unit_id: "currency"
        }
    }
}

const bonusesManager = {
    groups: [
        {
            id: "month",
            total: {
                name: "Итого за месяц",
                value: {
                    amount: 0,
                    unit_id: "currency"
                }
            }
        },
        {
            id: "quarter",
            total: {
                name: "Итого за квартал",
                value: {
                    amount: 0,
                    unit_id: "currency"
                }
            }
        },
        {
            id: "year",
            total: {
                name: "Итого за год",
                value: {
                    amount: 0,
                    unit_id: "currency"
                }
            }
        }
    ],
    items: [
        {
            group_id: "month",
            name: "Процент от продаж",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение нормы прироста продаж",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение нормы прироста новых клиентов",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение плана в магазине",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение плана по конверсии продаж",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение плана продаж по продукции КИ",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение квартального плана продаж",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы по сумме среднего чека",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы по емкости чека",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы продаж продукции",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы продаж от оборота бутика",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "year",
            name: "Бонус за выполнение нормы прироста продаж",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        }
    ],
    total: {
        name: "Всего бонусов",
        value: {
            amount: 0,
            unit_id: "currency"
        }
    }
}

const bonusesTerritorial = {
    groups: [
        {
            id: "month",
            total: {
                name: "Итого за месяц",
                value: {
                    amount: 0,
                    unit_id: "currency"
                }
            }
        },
        {
            id: "quarter",
            total: {
                name: "Итого за квартал",
                value: {
                    amount: 0,
                    unit_id: "currency"
                }
            }
        }
    ],
    items: [
        {
            group_id: "month",
            name: "Процент от продаж",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение плана КИ",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение плана по емкости чека",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение плана по среднему чеку",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение нормы по общему приросту продаж",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение нормы по приросту продаж L2L",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение плана по продаже товаров Outlet",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "month",
            name: "Бонус за выполнение нормы +5% к кусту ",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы продаж продукции",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы продаж домашней одежды",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы плана сотрудниками куста: консультантами",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        },
        {
            group_id: "quarter",
            name: "Бонус за выполнение нормы плана сотрудниками куста: дизайнерами",
            value: {
                amount: 0,
                unit_id: "currency"
            },
        }
    ],
    total: {
        name: "Всего бонусов",
        value: {
            amount: 0,
            unit_id: "currency"
        }
    }
}
export const generateDesignerDashboard = () => {
    return generateDashboard({
        month: monthContentDesigner,
        quarter: quarterContentDesigner,
        year: null,
        bonuses: bonusesDesigner
    })
}

export const generateConsultantDashboard = () => {
    return generateDashboard({
        month: monthContentConsultant,
        quarter: quarterContentConsultant,
        year: null,
        bonuses: bonusesConsultant
    })
}

export const generateManagerDashboard = () => {
    return generateDashboard({
        month: monthContentManager,
        quarter: quarterContentManager,
        year: yearContentManager,
        bonuses: bonusesManager
    })
}

export const generateTerritorialDashboard = () => {
    return generateDashboard({
        month: monthContentTerritorial,
        quarter: quarterContentTerritorial,
        year: yearContentTerritorial,
        bonuses: bonusesTerritorial
    })
}
